
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("lEQpi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hWRJP = parcelRequire("hWRJP");


var $dh538 = parcelRequire("dh538");


var $ejAeh = parcelRequire("ejAeh");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $QkKjT = parcelRequire("QkKjT");


var $gtauf = parcelRequire("gtauf");


var $3RNNl = parcelRequire("3RNNl");


var $dBGrG = parcelRequire("dBGrG");

class $f2fbfd8272c84174$export$d353efb45bc662f4 {
    isSyncBlock(node) {
        return this.sourceSyncBlockStoreManager.isSourceBlock(node) || this.referenceSyncBlockStoreManager.isReferenceBlock(node);
    }
    async fetchReferencesSourceInfo(resourceId, blockInstanceId, isSourceSyncBlock) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            this.fetchReferencesExperience?.start();
            const response = await this.dataProvider.fetchReferences(resourceId, isSourceSyncBlock);
            if (response.error) {
                this.fetchReferencesExperience?.failure({
                    reason: response.error
                });
                return {
                    error: response.error
                };
            }
            if (!response.references || response.references?.length === 0) return this.getUnregisteredReferences(resourceId, blockInstanceId, isSourceSyncBlock);
            this.fetchReferencesExperience?.success();
            const sourceInfoPromises = (response.references ?? []).map(async (reference)=>{
                this.fetchSourceInfoExperience?.start();
                const sourceInfo = await this.dataProvider?.fetchSyncBlockSourceInfo(reference.blockInstanceId || '', reference.documentAri, (0, $ejAeh.getProductFromSourceAri)(reference.documentAri), reference.hasAccess);
                if (!sourceInfo) {
                    this.fetchSourceInfoExperience?.failure({
                        reason: `no source info returned for ari: ${reference.documentAri}`
                    });
                    return undefined;
                }
                this.fetchSourceInfoExperience?.success();
                return {
                    ...sourceInfo,
                    onSameDocument: reference.onSameDocument,
                    hasAccess: reference.hasAccess,
                    productType: sourceInfo.productType
                };
            });
            const sourceInfos = await Promise.all(sourceInfoPromises);
            const sourceSyncBlockData = await (isSourceSyncBlock ? this.sourceSyncBlockStoreManager.getSyncBlockSourceInfo(blockInstanceId) : this.referenceSyncBlockStoreManager.fetchSyncBlockSourceInfo(resourceId));
            if (sourceSyncBlockData) sourceInfos.push({
                ...sourceSyncBlockData,
                onSameDocument: Boolean(sourceSyncBlockData?.onSameDocument),
                hasAccess: true,
                isSource: true,
                productType: sourceSyncBlockData?.productType
            });
            return {
                references: sourceInfos
            };
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchReferencesErrorPayload)(error.message, resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId)));
            return {
                error: (0, $awHlv.SyncBlockError).Errored
            };
        }
    }
    setFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
        this.referenceSyncBlockStoreManager.setFireAnalyticsEvent(fireAnalyticsEvent);
        this.sourceSyncBlockStoreManager.setFireAnalyticsEvent(fireAnalyticsEvent);
        this.fetchReferencesExperience = (0, $QkKjT.getFetchReferencesExperience)(fireAnalyticsEvent);
        this.fetchSourceInfoExperience = (0, $QkKjT.getFetchSourceInfoExperience)(fireAnalyticsEvent);
    }
    get referenceManager() {
        return this.referenceSyncBlockStoreManager;
    }
    get sourceManager() {
        return this.sourceSyncBlockStoreManager;
    }
    destroy() {
        this.referenceSyncBlockStoreManager.destroy();
        this.sourceSyncBlockStoreManager.destroy();
        this.fetchReferencesExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchSourceInfoExperience?.abort({
            reason: 'editorDestroyed'
        });
    }
    async getUnregisteredReferences(resourceId, blockInstanceId, isSourceSyncBlock) {
        // No reference found
        if (isSourceSyncBlock) {
            // Verify that a reference sync block for this specific source actually
            // exists on the current page by checking if the reference manager has
            // an active subscription for the derived reference resourceId.
            const referenceResourceId = this.referenceSyncBlockStoreManager.generateResourceIdForReference(resourceId);
            const hasUnregisteredReferenceOnPage = this.referenceSyncBlockStoreManager.getSubscribedResourceIds().includes(referenceResourceId);
            if (hasUnregisteredReferenceOnPage) {
                // This is current page data. It is the same for data for source and reference
                const sourceSyncBlockData = await this.sourceSyncBlockStoreManager.getSyncBlockSourceInfo(blockInstanceId);
                const references = [];
                if (sourceSyncBlockData) {
                    const sourceSyncBlockReference = {
                        ...sourceSyncBlockData,
                        onSameDocument: true,
                        hasAccess: true,
                        isSource: true
                    };
                    const referenceSyncBlockReference = {
                        ...sourceSyncBlockData,
                        onSameDocument: true,
                        hasAccess: true,
                        isSource: false
                    };
                    references.push(sourceSyncBlockReference, referenceSyncBlockReference);
                }
                this.fetchReferencesExperience?.success();
                return {
                    references: references
                };
            }
            // No remote or local reference exists — show info text with link to doco on how to use Synced Blocks
            this.fetchReferencesExperience?.success();
            return {
                references: []
            };
        }
        // Though no references registered yet for this reference sync block,
        // still show the source and the current page itself since they are known
        // but not saved yet.
        const references = [];
        const sourceSyncBlockData = await this.referenceSyncBlockStoreManager.fetchSyncBlockSourceInfo(resourceId);
        if (sourceSyncBlockData) references.push({
            ...sourceSyncBlockData,
            onSameDocument: Boolean(sourceSyncBlockData?.onSameDocument),
            hasAccess: true,
            isSource: true
        });
        const currentPageData = await this.referenceSyncBlockStoreManager.fetchSyncBlockSourceInfoByLocalId(blockInstanceId);
        if (currentPageData) references.push({
            ...currentPageData,
            onSameDocument: true,
            hasAccess: true,
            isSource: false
        });
        if (references.length === 0) {
            this.fetchReferencesExperience?.failure({
                reason: 'No references found for reference synced block'
            });
            return {
                error: (0, $awHlv.SyncBlockError).Errored
            };
        }
        this.fetchReferencesExperience?.success();
        return {
            references: references
        };
    }
    constructor(dataProvider, viewMode, isLivePage){
        this.referenceSyncBlockStoreManager = void 0;
        this.sourceSyncBlockStoreManager = void 0;
        this.dataProvider = void 0;
        this.fireAnalyticsEvent = void 0;
        this.fetchReferencesExperience = void 0;
        this.fetchSourceInfoExperience = void 0;
        // In future, if reference manager needs to reach to source manager and read its current in memory cache
        // we can pass the source manager as a parameter to the reference manager constructor
        this.sourceSyncBlockStoreManager = new (0, $dBGrG.SourceSyncBlockStoreManager)(dataProvider, viewMode, isLivePage);
        this.referenceSyncBlockStoreManager = new (0, $3RNNl.ReferenceSyncBlockStoreManager)(dataProvider, viewMode);
        this.dataProvider = dataProvider;
        this.referenceSyncBlockStoreManager.setRealTimeSubscriptionsEnabled(true);
    }
}
const $f2fbfd8272c84174$var$createSyncBlockStoreManager = (dataProvider)=>{
    return new $f2fbfd8272c84174$export$d353efb45bc662f4(dataProvider);
};
const $f2fbfd8272c84174$export$d95b04bc16414394 = (dataProvider, fireAnalyticsEvent)=>{
    const syncBlockStoreManager = (0, $42omo.useMemo)(()=>{
        return $f2fbfd8272c84174$var$createSyncBlockStoreManager(dataProvider);
    }, [
        dataProvider
    ]);
    const prevFireAnalyticsEventRef = (0, $42omo.useRef)(undefined);
    if (fireAnalyticsEvent !== prevFireAnalyticsEventRef.current) {
        prevFireAnalyticsEventRef.current = fireAnalyticsEvent;
        syncBlockStoreManager.setFireAnalyticsEvent(fireAnalyticsEvent);
    }
    // Gated by platform_synced_block_patch_14:
    // Destroy the SyncBlockStoreManager when:
    //   (a) the component unmounts — manager is fully cleaned up, or
    //   (b) dataProvider changes — the old manager (now orphaned by the
    //       useMemo recalculation) is destroyed before the new one takes over.
    //
    // Without this, orphaned managers leak timers, GQL subscriptions, and
    // in-flight fetches indefinitely. The effect dep is `syncBlockStoreManager`
    // (the useMemo result) — it changes identity precisely when dataProvider
    // changes, triggering the cleanup for the old instance.
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if ((0, $dh538.fg)('platform_synced_block_patch_14')) syncBlockStoreManager.destroy();
        };
    }, [
        syncBlockStoreManager
    ]);
    return syncBlockStoreManager;
};
module.exports["SyncBlockStoreManager"] = $f2fbfd8272c84174$export$d353efb45bc662f4;
module.exports["useMemoizedSyncBlockStoreManager"] = $f2fbfd8272c84174$export$d95b04bc16414394;

});

parcelRegister("QkKjT", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $grmt9 = parcelRequire("grmt9");

var $8kPu1 = parcelRequire("8kPu1");

var $fo9p3 = parcelRequire("fo9p3");

const $48856e1ef5d8a6d7$var$TIMEOUT_DURATION = 30000;
const $48856e1ef5d8a6d7$export$b335cfa3334e49e6 = (fireAnalyticsEvent)=>{
    return (payload)=>{
        // Runtime type guard - only forward experience events
        if (payload.action === (0, $d925B.ACTION).EXPERIENCE_MEASURED || payload.action === (0, $d925B.ACTION).EXPERIENCE_SAMPLED) fireAnalyticsEvent?.(payload);
    };
};
const $48856e1ef5d8a6d7$export$553df56755696c09 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_UPDATE,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$188e7890e84f55e4 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).REFERENCE_SYNCED_BLOCK_UPDATE,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$bbbbcdec37b3c0c0 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_FETCH,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$cf32ad2bf7484097 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_GET_SOURCE_INFO,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$666920a07aaa7d43 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_DELETE,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$bf943e4a2bda18f6 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_CREATE,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$3ba8782eb93c9adf = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_FETCH_REFERENCES,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
module.exports["getSaveSourceExperience"] = $48856e1ef5d8a6d7$export$553df56755696c09;
module.exports["getSaveReferenceExperience"] = $48856e1ef5d8a6d7$export$188e7890e84f55e4;
module.exports["getFetchExperience"] = $48856e1ef5d8a6d7$export$bbbbcdec37b3c0c0;
module.exports["getFetchSourceInfoExperience"] = $48856e1ef5d8a6d7$export$cf32ad2bf7484097;
module.exports["getDeleteSourceExperience"] = $48856e1ef5d8a6d7$export$666920a07aaa7d43;
module.exports["getCreateSourceExperience"] = $48856e1ef5d8a6d7$export$bf943e4a2bda18f6;
module.exports["getFetchReferencesExperience"] = $48856e1ef5d8a6d7$export$3ba8782eb93c9adf;

});

parcelRegister("3RNNl", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $hWRJP = parcelRequire("hWRJP");


var $dh538 = parcelRequire("dh538");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $QkKjT = parcelRequire("QkKjT");


var $4wATI = parcelRequire("4wATI");


var $gtauf = parcelRequire("gtauf");


var $dyHCj = parcelRequire("dyHCj");


var $bBz3A = parcelRequire("bBz3A");


var $cTANx = parcelRequire("cTANx");


var $axlAB = parcelRequire("axlAB");

const $bf9ff2ea047058dc$var$CACHE_KEY_PREFIX = 'sync-block-data-';
const $bf9ff2ea047058dc$var$ENTITY_NOT_FOUND_MAX_RETRIES = 3;
const $bf9ff2ea047058dc$var$ENTITY_NOT_FOUND_INITIAL_DELAY_MS = 2000;
// Grace period before a cache entry is removed after the last subscriber
// unsubscribes (gated by `platform_synced_block_patch_14`). Guards are
// re-checked at fire time; if any are positive, the timer is rescheduled.
const $bf9ff2ea047058dc$var$CACHE_DELETION_GRACE_PERIOD_MS = 30000;
// Max reschedules before force-deleting with an analytics event (~5 min).
const $bf9ff2ea047058dc$var$CACHE_DELETION_MAX_RESCHEDULES = 10;
class $bf9ff2ea047058dc$export$fb04276dca31302e {
    isReferenceBlock(node) {
        return node.type.name === 'syncBlock';
    }
    /**
   * Whether the async data provider is wired and the manager is not torn down.
   * Consumers gate fetch/subscribe on this to avoid a false `Data provider not
   * set` fetch error (EDITOR-7860). The `isDestroyed` check covers managers
   * orphaned mid-flight during an async provider swap, where `dataProvider`
   * alone is insufficient.
   */ hasDataProvider() {
        return !this.isDestroyed && !!this.dataProvider;
    }
    /**
   * Enables or disables real-time GraphQL subscriptions for block updates.
   * When enabled, the store manager will subscribe to real-time updates
   * instead of relying on polling.
   * @param enabled - Whether to enable real-time subscriptions
   */ setRealTimeSubscriptionsEnabled(enabled) {
        this._subscriptionManager.setRealTimeSubscriptionsEnabled(enabled);
    }
    /**
   * Checks if real-time subscriptions are currently enabled.
   */ isRealTimeSubscriptionsEnabled() {
        return this._subscriptionManager.isRealTimeSubscriptionsEnabled();
    }
    /**
   * Returns all resource IDs that are currently subscribed to.
   * Used by React components to render subscription components.
   */ getSubscribedResourceIds() {
        return this._subscriptionManager.getSubscribedResourceIds();
    }
    /**
   * Registers a listener that will be called when subscriptions change.
   * @param listener - Callback function to invoke when subscriptions change
   * @returns Unsubscribe function to remove the listener
   */ onSubscriptionsChanged(listener) {
        return this._subscriptionManager.onSubscriptionsChanged(listener);
    }
    /**
   * Handles incoming data from a GraphQL subscription.
   * Called by React subscription components when they receive updates.
   * @param syncBlockInstance - The updated sync block instance
   */ handleSubscriptionUpdate(syncBlockInstance) {
        this._subscriptionManager.handleSubscriptionUpdate(syncBlockInstance);
    }
    setFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
        this.fetchExperience = (0, $QkKjT.getFetchExperience)(fireAnalyticsEvent);
        this.fetchSourceInfoExperience = (0, $QkKjT.getFetchSourceInfoExperience)(fireAnalyticsEvent);
        this.saveExperience = (0, $QkKjT.getSaveReferenceExperience)(fireAnalyticsEvent);
    }
    setOnUnpublishedSyncBlockDetected(callback) {
        this.onUnpublishedSyncBlockDetected = callback;
    }
    /**
   * Mark a sync block as newly added to the document.
   * This should be called when a sync block node is added via a transaction.
   * @param resourceId - The resource ID of the newly added sync block
   */ markAsNewlyAdded(resourceId) {
        this.newlyAddedSyncBlocks.add(resourceId);
    }
    generateResourceIdForReference(sourceId) {
        if (!this.dataProvider) throw new Error('Data provider not set');
        return this.dataProvider.generateResourceIdForReference(sourceId);
    }
    updateFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
    }
    getInitialSyncBlockData(resourceId) {
        const syncBlockNode = (0, $gtauf.createSyncBlockNode)('', resourceId);
        const providerData = this.dataProvider?.getNodeDataFromCache(syncBlockNode)?.data;
        if (providerData) // Initial provider cache data can come from SSR/prefetch and bypass updateCache(),
        // so normalize legacy reference payloads here before rendering.
        return this.normalizeReferenceData(providerData);
        return this.getFromSessionCache(resourceId);
    }
    normalizeReferenceData(syncBlock) {
        if (!syncBlock.data?.content?.length) return syncBlock;
        const content = (0, $gtauf.normalizeSyncBlockJSONContent)(syncBlock.data.content);
        if (content === syncBlock.data.content) return syncBlock;
        return {
            ...syncBlock,
            data: {
                ...syncBlock.data,
                content: content
            }
        };
    }
    updateSessionCache(resourceId) {
        const latestData = this.getFromCache(resourceId);
        if (latestData) (0, $bBz3A.syncBlockInMemorySessionCache).setItem(`${$bf9ff2ea047058dc$var$CACHE_KEY_PREFIX}${resourceId}`, JSON.stringify(latestData));
    }
    getFromSessionCache(resourceId) {
        try {
            const raw = (0, $bBz3A.syncBlockInMemorySessionCache).getItem(`${$bf9ff2ea047058dc$var$CACHE_KEY_PREFIX}${resourceId}`);
            if (!raw) return undefined;
            // Session cache entries written before this sanitizer existed may still include
            // annotation marks or panel_c1 nodes, so keep this read-time safety net for legacy data.
            return this.normalizeReferenceData(JSON.parse(raw));
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/getFromSessionCache'
            });
            return undefined;
        }
    }
    fetchSyncBlockSourceInfoBySourceAri(sourceAri, hasAccess = true) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            const sourceInfo = this.dataProvider.fetchSyncBlockSourceInfo(undefined, sourceAri, undefined, hasAccess);
            return sourceInfo;
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/fetchSyncBlockSourceInfoBySourceAri'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message));
            return Promise.resolve(undefined);
        }
    }
    fetchSyncBlockSourceInfoByLocalId(localId, hasAccess = true) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            return this.dataProvider.fetchSyncBlockSourceInfo(localId, undefined, undefined, hasAccess);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/fetchSyncBlockSourceInfoByLocalId'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message));
            return Promise.resolve(undefined);
        }
    }
    fetchSyncBlockSourceInfo(resourceId) {
        try {
            if (!resourceId || !this.dataProvider) throw new Error('Data provider or resourceId not set');
            const existingRequest = this.syncBlockSourceInfoRequests.get(resourceId);
            if (existingRequest) return existingRequest;
            const existingSyncBlock = this.getFromCache(resourceId);
            if (!existingSyncBlock) throw new Error('No existing sync block to fetch source info for');
            const { sourceAri: sourceAri, product: product, blockInstanceId: blockInstanceId, sourceURL: sourceURL, sourceTitle: sourceTitle, onSameDocument: onSameDocument, sourceSubType: sourceSubType, issueType: issueType } = existingSyncBlock.data || {};
            // skip if source URL and title are already present
            if (sourceURL && sourceTitle) return Promise.resolve({
                title: sourceTitle,
                url: sourceURL,
                subType: sourceSubType,
                sourceAri: sourceAri || '',
                onSameDocument: onSameDocument,
                productType: product,
                issueType: issueType
            });
            // Derive once per call so we don't re-parse on every analytics event below.
            // `product` from cached data is preferred when available; fall back to parsing
            // the resourceId.
            const sourceProduct = product ?? (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId);
            if (!sourceAri || !product || !blockInstanceId) {
                this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)('SourceAri, product or blockInstanceId missing', resourceId, sourceProduct));
                return Promise.resolve(undefined);
            }
            this.fetchSourceInfoExperience?.start({});
            const sourceInfoPromise = this.dataProvider.fetchSyncBlockSourceInfo(blockInstanceId, sourceAri, product, true // hasAccess
            ).then((sourceInfo)=>{
                if (!sourceInfo) {
                    this.fetchSourceInfoExperience?.failure({
                        reason: 'No source info returned'
                    });
                    this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)('No source info returned', resourceId, sourceProduct));
                    return undefined;
                }
                this.updateCacheWithSourceInfo(resourceId, sourceInfo);
                if (sourceInfo.title) this._subscriptionManager.updateSourceTitleSubscriptions(resourceId, sourceInfo.title);
                if (sourceInfo.title && sourceInfo.url) this.fetchSourceInfoExperience?.success();
                else {
                    this.fetchSourceInfoExperience?.failure({
                        reason: 'Missing title or url'
                    });
                    this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)('Missing title or url', resourceId, sourceProduct));
                }
                return sourceInfo;
            }).catch((error)=>{
                this.fetchSourceInfoExperience?.failure({
                    reason: error.message
                });
                this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message, resourceId, sourceProduct));
                return undefined;
            }).finally(()=>{
                this.syncBlockSourceInfoRequests.delete(resourceId);
            });
            this.syncBlockSourceInfoRequests.set(resourceId, sourceInfoPromise);
            return sourceInfoPromise;
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message, resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId)));
        }
        return Promise.resolve(undefined);
    }
    /**
   * Processes prefetched data and updates the cache.
   * @param prefetchedData - The prefetched data to process
   * @returns {Promise<void>}
   */ async processPrefetchedData(prefetchedData) {
        if (!prefetchedData) return;
        // start the fetch experience (this should be started much earlier to properly track performance, but better late than never)
        this.fetchExperience?.start({});
        // mark the sync block requests as in fly
        prefetchedData.resourceIds.forEach((resourceId)=>{
            this.syncBlockFetchDataRequests.set(resourceId, true);
        });
        try {
            const prefetchedResolvedData = await prefetchedData.prefetchPromise;
            const { hasUnexpectedError: hasUnexpectedError, hasExpectedError: hasExpectedError } = this.processFetchedData(prefetchedResolvedData);
            if (hasUnexpectedError) this.fetchExperience?.failure({
                reason: 'Unexpected error during prefetch'
            });
            else if (hasExpectedError) this.fetchExperience?.abort({
                reason: 'Expected error: NotFound or PermissionDenied during prefetch'
            });
            else this.fetchExperience?.success();
        } catch (error) {
            this.fetchExperience?.failure({
                reason: `Prefetch promise rejected: ${error.message}`
            });
        } finally{
            // Clean up in-flight markers so subsequent fetches are not blocked
            prefetchedData.resourceIds.forEach((resourceId)=>{
                this.syncBlockFetchDataRequests.delete(resourceId);
            });
        }
    }
    /**
   * Fetch sync block data for a given array of sync block nodes.
   * @param syncBlockNodes - The array of sync block nodes to fetch data for
   * @returns The fetched sync block data results
   */ async fetchSyncBlocksData(syncBlockNodes) {
        if (syncBlockNodes.length === 0) return;
        // Don't fetch for not_found error since the source is already deleted
        const nodesToFetch = [];
        syncBlockNodes.forEach((node)=>{
            if (this.syncBlockFetchDataRequests.get(node.attrs.resourceId)) return;
            const existingSyncBlock = this.getFromCache(node.attrs.resourceId);
            if (existingSyncBlock?.error?.type === (0, $awHlv.SyncBlockError).NotFound) return;
            nodesToFetch.push(node);
        });
        if (nodesToFetch.length === 0) return;
        if (!this.dataProvider) {
            // EDITOR-7860: tag the throw so catch sites can suppress the benign
            // not-ready/torn-down case. Gate-off keeps the legacy throw + message.
            if ((0, $dh538.fg)('platform_editor_blocks_patch_3')) throw new (0, $awHlv.ProviderNotReadyError)();
            throw new Error('Data provider not set');
        }
        nodesToFetch.forEach((node)=>{
            this.syncBlockFetchDataRequests.set(node.attrs.resourceId, true);
        });
        this.fetchExperience?.start({});
        const data = await this.dataProvider.fetchNodesData(nodesToFetch).finally(()=>{
            nodesToFetch.forEach((node)=>{
                this.syncBlockFetchDataRequests.delete(node.attrs.resourceId);
            });
        });
        const { hasUnexpectedError: hasUnexpectedError, hasExpectedError: hasExpectedError } = this.processFetchedData(data);
        if (hasUnexpectedError) this.fetchExperience?.failure({
            reason: 'Unexpected error during fetch'
        });
        else if (hasExpectedError) this.fetchExperience?.abort({
            reason: 'Expected error: NotFound or PermissionDenied'
        });
        else this.fetchExperience?.success();
    }
    processFetchedData(data) {
        if (!data) return {
            hasUnexpectedError: false,
            hasExpectedError: false
        };
        let hasUnexpectedError = false;
        let hasExpectedError = false;
        data.forEach((syncBlockInstance)=>{
            if (!syncBlockInstance.resourceId) {
                const payload = syncBlockInstance.error?.reason || syncBlockInstance.error?.type || 'Returned sync block instance does not have resource id';
                // No resourceId means we cannot derive a sourceProduct here; intentionally omit.
                // Classify on the structured `type` first, falling back to the free-text
                // `reason`/payload (EDITOR-7862).
                this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(payload, undefined, undefined, (0, $cFpEg.buildFetchErrorAttribution)((0, $dh538.fg)('platform_editor_blocks_patch_3'), syncBlockInstance.error?.type || syncBlockInstance.error?.reason || payload, syncBlockInstance.error?.statusCode)));
                return;
            }
            const existingSyncBlock = this.getFromCache(syncBlockInstance.resourceId);
            const resolvedSyncBlockInstance = existingSyncBlock ? (0, $4wATI.resolveSyncBlockInstance)(existingSyncBlock, syncBlockInstance) : syncBlockInstance;
            this.updateCache(resolvedSyncBlockInstance);
            // Check if this is a newly added unpublished sync block and notify
            // Only trigger for sync blocks that were just added (not refreshed or loaded on page init)
            if (!syncBlockInstance.error && resolvedSyncBlockInstance.data?.status === 'unpublished' && this.newlyAddedSyncBlocks.has(syncBlockInstance.resourceId) && this.onUnpublishedSyncBlockDetected) {
                // Remove from newly added set after checking to prevent duplicate flags
                this.newlyAddedSyncBlocks.delete(syncBlockInstance.resourceId);
                this.onUnpublishedSyncBlockDetected(resolvedSyncBlockInstance.resourceId);
            } else if (this.newlyAddedSyncBlocks.has(syncBlockInstance.resourceId)) // Remove from newly added set even if not unpublished (to clean up)
            this.newlyAddedSyncBlocks.delete(syncBlockInstance.resourceId);
            // Clear retry tracking on successful fetch — block has been created
            if (!syncBlockInstance.error && this.entityNotFoundRetryCount.has(syncBlockInstance.resourceId)) {
                const timer = this.entityNotFoundRetryTimers.get(syncBlockInstance.resourceId);
                if (timer) {
                    clearTimeout(timer);
                    this.entityNotFoundRetryTimers.delete(syncBlockInstance.resourceId);
                }
                this.entityNotFoundRetryCount.delete(syncBlockInstance.resourceId);
            }
            if (syncBlockInstance.error) {
                // Skip error analytics when EntityNotFound will be retried, to avoid
                // inflating error-rate metrics with expected transient failures
                const isRetryingEntityNotFound = syncBlockInstance.error.type === (0, $awHlv.SyncBlockError).EntityNotFound && (this.entityNotFoundRetryCount.get(syncBlockInstance.resourceId) ?? 0) < $bf9ff2ea047058dc$var$ENTITY_NOT_FOUND_MAX_RETRIES && (0, $dh538.fg)('platform_synced_block_patch_13');
                if (!isRetryingEntityNotFound) // Classify on the structured `type` (a `SyncBlockError` enum value) first,
                // falling back to the free-text `reason` so source-state/permission strings
                // are still bucketed (EDITOR-7862). The emitted `error` attribute is unchanged.
                this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(syncBlockInstance.error.reason || syncBlockInstance.error.type, syncBlockInstance.resourceId, syncBlockInstance.data?.product ?? (0, $gtauf.getSourceProductFromResourceIdSafe)(syncBlockInstance.resourceId), (0, $cFpEg.buildFetchErrorAttribution)((0, $dh538.fg)('platform_editor_blocks_patch_3'), syncBlockInstance.error.type || syncBlockInstance.error.reason, syncBlockInstance.error.statusCode)));
                if (syncBlockInstance.error.type === (0, $awHlv.SyncBlockError).NotFound || syncBlockInstance.error.type === (0, $awHlv.SyncBlockError).Forbidden) hasExpectedError = true;
                else if (syncBlockInstance.error.type === (0, $awHlv.SyncBlockError).EntityNotFound) {
                    // Schedule a retry for EntityNotFound — the source block may be in
                    // the process of being created by a collaborator (race condition
                    // between NCS propagation and Block Service createBlock call).
                    if ((0, $dh538.fg)('platform_synced_block_patch_13')) this.scheduleEntityNotFoundRetry(syncBlockInstance.resourceId);
                    if (!isRetryingEntityNotFound) hasUnexpectedError = true;
                } else if (syncBlockInstance.error) hasUnexpectedError = true;
                return;
            }
            const callbacks = this._subscriptionManager.getSubscriptions().get(syncBlockInstance.resourceId);
            const localIds = callbacks ? Object.keys(callbacks) : [];
            localIds.forEach((localId)=>{
                this.fireAnalyticsEvent?.((0, $cFpEg.fetchSuccessPayload)(syncBlockInstance.resourceId, localId, syncBlockInstance.data?.product ?? (0, $gtauf.getSourceProductFromResourceIdSafe)(syncBlockInstance.resourceId)));
            });
            this.fetchSyncBlockSourceInfo(resolvedSyncBlockInstance.resourceId);
        });
        return {
            hasUnexpectedError: hasUnexpectedError,
            hasExpectedError: hasExpectedError
        };
    }
    updateCacheWithSourceInfo(resourceId, sourceInfo) {
        const existingSyncBlock = this.getFromCache(resourceId);
        // If the cache entry was deleted while the source-info request was
        // in flight, fire an analytics event so the race is observable.
        if (!existingSyncBlock && (0, $dh538.fg)('platform_synced_block_patch_14')) {
            this.fireAnalyticsEvent?.((0, $cFpEg.sourceInfoOrphanedPayload)(resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId), {
                hasPendingDeletion: this.pendingCacheDeletions.has(resourceId),
                hasSubscribers: this._subscriptionManager.getSubscriptions().has(resourceId)
            }));
            (0, $hWRJP.logException)(new Error('updateCacheWithSourceInfo: cache entry missing for resource'), {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/orphaned-source-info'
            });
            return;
        }
        if (existingSyncBlock && existingSyncBlock.data) {
            existingSyncBlock.data.sourceURL = sourceInfo?.url;
            existingSyncBlock.data = {
                ...existingSyncBlock.data,
                sourceURL: sourceInfo?.url,
                sourceTitle: sourceInfo?.title,
                onSameDocument: sourceInfo?.onSameDocument,
                sourceSubType: sourceInfo?.subType,
                issueType: sourceInfo?.issueType
            };
            this.updateCache(existingSyncBlock);
        }
    }
    updateCache(syncBlock) {
        const sanitizedSyncBlock = this.normalizeReferenceData(syncBlock);
        const { resourceId: resourceId } = sanitizedSyncBlock;
        if (resourceId) {
            this.dataProvider?.updateCache({
                [resourceId]: sanitizedSyncBlock
            }, {
                strategy: 'merge',
                source: 'network'
            });
            this._subscriptionManager.notifySubscriptionCallbacks(resourceId, sanitizedSyncBlock);
            this.updateSessionCache(resourceId);
        }
    }
    getFromCache(resourceId) {
        const syncBlockNode = (0, $gtauf.createSyncBlockNode)('', resourceId);
        return this.dataProvider?.getNodeDataFromCache(syncBlockNode)?.data;
    }
    deleteFromCache(resourceId) {
        this.dataProvider?.removeFromCache([
            resourceId
        ]);
        this._providerFactoryManager.deleteFactory(resourceId);
        // Evict in-flight source-info promise and reset reschedule counter
        // so a stale resolution can't silently merge into a re-fetched entry.
        if ((0, $dh538.fg)('platform_synced_block_patch_14')) {
            this.syncBlockSourceInfoRequests.delete(resourceId);
            this.cacheDeletionRescheduleCounts.delete(resourceId);
        }
    }
    /**
   * Returns true if the cache entry for `resourceId` is safe to delete:
   * no active subscribers, no in-flight source-info request, and no
   * queued/in-flight batch fetch (gated by `platform_synced_block_patch_14`).
   */ canDeleteCache(resourceId) {
        if (this._subscriptionManager.getSubscriptions().has(resourceId)) return false;
        if (this.syncBlockSourceInfoRequests.has(resourceId)) return false;
        if (this._batchFetcher.hasPendingFetch(resourceId)) return false;
        return true;
    }
    /**
   * Schedules cache deletion for `resourceId` after the grace period
   * (gated by `platform_synced_block_patch_14`). Called when the last
   * subscriber unsubscribes. Guards are re-checked at fire time; if any
   * are positive the timer is rescheduled up to MAX_RESCHEDULES times.
   */ scheduleCacheDeletion(resourceId) {
        if (!(0, $dh538.fg)('platform_synced_block_patch_14')) return;
        if (this.isDestroyed) return;
        // Cancel any existing timer \u2014 restart the grace period \u2014 but DO NOT
        // reset the reschedule counter. The counter is reset only by
        // `cancelPendingCacheDeletion` (called when a real subscriber returns)
        // or when the cache is actually deleted.
        const existing = this.pendingCacheDeletions.get(resourceId);
        if (existing) {
            clearTimeout(existing);
            this.pendingCacheDeletions.delete(resourceId);
        }
        const timer = setTimeout(()=>{
            // Guard against timer callback running after destroy. clearTimeout
            // is synchronous so this should be unreachable in practice, but
            // belt-and-braces.
            if (this.isDestroyed) return;
            this.pendingCacheDeletions.delete(resourceId);
            this.onCacheDeletionTimerFire(resourceId);
        }, $bf9ff2ea047058dc$var$CACHE_DELETION_GRACE_PERIOD_MS);
        this.pendingCacheDeletions.set(resourceId, timer);
    }
    /**
   * Cancels any pending cache deletion timer for `resourceId` and resets the
   * reschedule counter (gated by `platform_synced_block_patch_14`). Called
   * when a new subscriber arrives.
   */ cancelPendingCacheDeletion(resourceId) {
        if (!(0, $dh538.fg)('platform_synced_block_patch_14')) return;
        const existing = this.pendingCacheDeletions.get(resourceId);
        if (existing) {
            clearTimeout(existing);
            this.pendingCacheDeletions.delete(resourceId);
        }
        // Subscribers returning resets the reschedule counter \u2014 the resource is
        // active again.
        this.cacheDeletionRescheduleCounts.delete(resourceId);
    }
    /** Returns whether a cache deletion timer is pending for `resourceId`. */ hasPendingCacheDeletion(resourceId) {
        return this.pendingCacheDeletions.has(resourceId);
    }
    onCacheDeletionTimerFire(resourceId) {
        if (this.canDeleteCache(resourceId)) {
            // `deleteFromCache` resets the reschedule counter under the flag.
            this.deleteFromCache(resourceId);
            return;
        }
        const currentCount = this.cacheDeletionRescheduleCounts.get(resourceId) ?? 0;
        if (currentCount >= $bf9ff2ea047058dc$var$CACHE_DELETION_MAX_RESCHEDULES) {
            // Stuck guard — force deletion to prevent unbounded memory growth and
            // fire analytics so the stuck state is visible in production telemetry.
            //
            // NOTE: If active React subscribers still exist at force-delete time
            // (e.g. an in-flight batch fetch never settled), the cache entry is
            // removed without notifying subscribers. Those components will
            // continue to render with stale data until their next re-render
            // triggers a new batch fetch — typically within ~1 frame. We accept
            // this brief stale window in exchange for bounded memory growth.
            this.fireAnalyticsEvent?.((0, $cFpEg.cacheDeletionForcedPayload)(currentCount, resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId)));
            (0, $hWRJP.logException)(new Error(`Cache deletion forced after ${currentCount} reschedules \u{2014} stuck in-flight guard`), {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/cache-deletion-forced'
            });
            // `deleteFromCache` resets the reschedule counter under the flag.
            this.deleteFromCache(resourceId);
            // If subscribers still exist, kick off a fresh fetch so they get
            // fresh data on the next batch tick instead of holding stale data
            // indefinitely.
            if (this._subscriptionManager.getSubscriptions().has(resourceId)) this.debouncedBatchedFetchSyncBlocks(resourceId);
            return;
        }
        this.cacheDeletionRescheduleCounts.set(resourceId, currentCount + 1);
        this.scheduleCacheDeletion(resourceId);
    }
    /**
   * Schedules a delayed retry for a block that returned EntityNotFound.
   * The block may be in the process of being created by a collaborator —
   * the NCS transaction propagates the bodiedSyncBlock ADF node before
   * the Block Service createBlock call completes.
   */ scheduleEntityNotFoundRetry(resourceId) {
        const currentRetries = this.entityNotFoundRetryCount.get(resourceId) ?? 0;
        if (currentRetries >= $bf9ff2ea047058dc$var$ENTITY_NOT_FOUND_MAX_RETRIES) // Max retries exceeded — keep count at max so future calls immediately exit
        // (don't delete — that would reset the counter and allow unbounded retry waves)
        return;
        // If a timer is already pending, don't schedule another one — let the
        // existing timer fire. This prevents rapid EntityNotFound responses from
        // exhausting the retry budget through cancellations without any actual
        // fetch completing.
        if (this.entityNotFoundRetryTimers.has(resourceId)) return;
        const delay = $bf9ff2ea047058dc$var$ENTITY_NOT_FOUND_INITIAL_DELAY_MS * Math.pow(2, currentRetries);
        const timer = setTimeout(()=>{
            this.entityNotFoundRetryTimers.delete(resourceId);
            // If no active subscriptions remain for this block, clean up and skip
            const subscriptions = this._subscriptionManager.getSubscriptions().get(resourceId);
            if (!subscriptions || Object.keys(subscriptions).length === 0) {
                this.entityNotFoundRetryCount.delete(resourceId);
                return;
            }
            // Increment count only when the timer fires, not when scheduled
            this.entityNotFoundRetryCount.set(resourceId, currentRetries + 1);
            // Clear the error from cache so fetchSyncBlocksData doesn't skip it
            const cached = this.getFromCache(resourceId);
            if (cached?.error?.type === (0, $awHlv.SyncBlockError).EntityNotFound) this.deleteFromCache(resourceId);
            // Trigger a re-fetch via the batch fetcher
            this.debouncedBatchedFetchSyncBlocks(resourceId);
        }, delay);
        this.entityNotFoundRetryTimers.set(resourceId, timer);
    }
    debouncedBatchedFetchSyncBlocks(resourceId) {
        this._batchFetcher.queueFetch(resourceId);
    }
    setSSRDataInSessionCache(resourceIds) {
        if (!resourceIds || resourceIds.length === 0) return;
        resourceIds.forEach((resourceId)=>{
            this.updateSessionCache(resourceId);
        });
    }
    subscribeToSyncBlock(resourceId, localId, callback) {
        return this._subscriptionManager.subscribeToSyncBlock(resourceId, localId, callback);
    }
    subscribeToSourceTitle(node, callback) {
        return this._subscriptionManager.subscribeToSourceTitle(node, callback);
    }
    subscribe(node, callback) {
        try {
            // check node is a sync block, as we only support sync block subscriptions
            if (node.type.name !== 'syncBlock') throw new Error('Only sync block node subscriptions are supported');
            const { resourceId: resourceId, localId: localId } = node.attrs;
            if (!localId || !resourceId) throw new Error('Missing local id or resource id');
            return this._subscriptionManager.subscribeToSyncBlock(resourceId, localId, callback);
        } catch (error) {
            // EDITOR-7860: benign not-ready/torn-down case — suppress both the
            // exception-tracker log and the analytics event (checked first so the
            // benign case stays fully silent). Gate-off behaviour is unchanged.
            if ((0, $awHlv.isProviderNotReadyError)(error) && (0, $dh538.fg)('platform_editor_blocks_patch_3')) return ()=>{};
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message, undefined, undefined, (0, $cFpEg.buildFetchErrorAttribution)((0, $dh538.fg)('platform_editor_blocks_patch_3'), error.message)));
            return ()=>{};
        }
    }
    /**
   * Get the URL for a sync block.
   * @param resourceId - The resource ID of the sync block
   * @returns
   */ getSyncBlockURL(resourceId) {
        return this.getFromCache(resourceId)?.data?.sourceURL;
    }
    getProviderFactory(resourceId) {
        return this._providerFactoryManager.getProviderFactory(resourceId);
    }
    getSSRProviders(resourceId) {
        return this._providerFactoryManager.getSSRProviders(resourceId);
    }
    /**
   * Update reference synced blocks on the document with the BE
   *
   * @returns true if the reference synced blocks are updated successfully, false otherwise
   */ async flush() {
        if (this.viewMode === 'view') // Reference flushes are only meaningful while editing. Treat view-mode flush attempts as
        // gated no-op successes so lifecycle/teardown calls do not report false save failures.
        return (0, $dh538.fg)('platform_editor_blocks_patch_2');
        if (!this.isCacheDirty) // we use the isCacheDirty flag as a quick check.
        return true;
        // Prevent concurrent flushes to avoid race conditions with lastFlushedSyncedBlocks
        if (this.isFlushInProgress) {
            // Mark that another flush is needed after the current one completes
            this.flushNeededAfterCurrent = true;
            // We return true here because we know the pending flush will handle the dirty cache
            return true;
        } else this.isFlushInProgress = true;
        let success = true;
        // a copy of the subscriptions STRUCTURE (without the callbacks)
        // To be saved as the last flushed structure if the flush is successful
        const syncedBlocksToFlush = {};
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            const blocks = [];
            // First, build the complete subscription structure
            for (const [resourceId, callbacks] of this._subscriptionManager.getSubscriptions().entries()){
                syncedBlocksToFlush[resourceId] = {};
                Object.keys(callbacks).forEach((localId)=>{
                    blocks.push({
                        resourceId: resourceId,
                        localId: localId
                    });
                    syncedBlocksToFlush[resourceId][localId] = true;
                });
            }
            // Then, compare with the last flushed structure to detect changes
            // We check against the last flushed structure to prevent unnecessary flushes
            // Note that we will always flush at least once when editor starts
            // This is useful for eventual consistency between the editor and the BE.
            if ((0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(syncedBlocksToFlush, this.lastFlushedSyncedBlocks)) {
                this.isCacheDirty = false; // Reset since we're considering this a successful no-op flush
                return true;
            }
            // reset isCacheDirty early to prevent race condition
            // There is a race condition where if a user makes changes (create/delete) to a reference sync block
            // on a live page and the reference sync block is being saved while the user
            // is still making changes, the new changes might not be saved if they all happen
            // exactly at a time when the updateReferenceData is being executed asynchronously.
            this.isCacheDirty = false;
            this.saveExperience?.start();
            const updateResult = await this.dataProvider.updateReferenceData(blocks);
            if (!updateResult.success) {
                success = false;
                this.saveExperience?.failure({
                    reason: updateResult.error || 'Failed to update reference synced blocks on the document'
                });
                this.fireAnalyticsEvent?.((0, $cFpEg.updateReferenceErrorPayload)(updateResult.error || 'Failed to update reference synced blocks on the document', undefined, undefined, (0, $cFpEg.buildErrorAttribution)((0, $dh538.fg)('platform_editor_blocks_patch_3'), updateResult.error, updateResult.statusCode)));
            }
        } catch (error) {
            success = false;
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.saveExperience?.failure({
                reason: error.message
            });
            // No `resourceId` available in this catch — sourceProduct is intentionally omitted.
            // No structured SyncBlockError/status here, so the attribution `reason` falls back
            // to `unknown` when the gate is on.
            this.fireAnalyticsEvent?.((0, $cFpEg.updateReferenceErrorPayload)(error.message, undefined, undefined, (0, $cFpEg.buildErrorAttribution)((0, $dh538.fg)('platform_editor_blocks_patch_3'))));
        } finally{
            if (!success) // set isCacheDirty back to true for cases where it failed to update the reference synced blocks on the BE
            this.isCacheDirty = true;
            else {
                this.lastFlushedSyncedBlocks = syncedBlocksToFlush;
                this.saveExperience?.success();
            }
            // Always reset isFlushInProgress
            this.isFlushInProgress = false;
            // If another flush was requested while this one was in progress, execute it now
            if (this.flushNeededAfterCurrent) {
                this.flushNeededAfterCurrent = false;
                // Use setTimeout to avoid deep recursion and run queued flush asynchronously
                // Note: flush() handles all exceptions internally and never rejects
                this.queuedFlushTimeout = setTimeout(()=>{
                    this.queuedFlushTimeout = undefined;
                    this.flush();
                }, 0);
            }
        }
        return success;
    }
    destroy() {
        // Mark destroyed first so in-flight timer callbacks can early-return.
        this.isDestroyed = true;
        // Cancel any queued flush to prevent it from running after destroy
        if (this.queuedFlushTimeout) {
            clearTimeout(this.queuedFlushTimeout);
            this.queuedFlushTimeout = undefined;
        }
        // Cancel any pending EntityNotFound retry timers
        this.entityNotFoundRetryTimers.forEach((timer)=>clearTimeout(timer));
        this.entityNotFoundRetryTimers.clear();
        this.entityNotFoundRetryCount.clear();
        // Cancel pending cache deletion timers.
        this.pendingCacheDeletions.forEach((timer)=>clearTimeout(timer));
        this.pendingCacheDeletions.clear();
        this.cacheDeletionRescheduleCounts.clear();
        this._subscriptionManager.destroy();
        this._providerFactoryManager.destroy();
        this._batchFetcher.destroy();
        this.dataProvider?.resetCache();
        this.dataProvider = undefined;
        this.syncBlockFetchDataRequests.clear();
        this.syncBlockSourceInfoRequests.clear();
        this.saveExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchSourceInfoExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fireAnalyticsEvent = undefined;
        // Under `platform_synced_block_patch_14`, `destroy()` is now wired to
        // React component unmount via `useMemoizedSyncBlockStoreManager`.
        // Clearing the module-level singleton on unmount would wipe SSR session
        // cache data that a sibling/successor manager (e.g. the editor
        // instance that mounts immediately after the renderer unmounts during
        // the view-mode transition) is about to read.
        // Let entries age out naturally instead — the in-memory cache is
        // naturally bounded by `maxSize` (LRU) and cleared on hard navigation.
        if (!(0, $dh538.fg)('platform_synced_block_patch_14')) (0, $bBz3A.syncBlockInMemorySessionCache).clear();
    }
    constructor(dataProvider, viewMode){
        this.viewMode = void 0;
        this.dataProvider = void 0;
        // Keeps track of addition and deletion of reference synced blocks on the document
        // This starts as true to always flush the cache when document is saved for the first time
        // to cater the case when a editor session is closed without document being updated right after reference block is deleted
        this.isCacheDirty = true;
        this.fireAnalyticsEvent = void 0;
        this.syncBlockFetchDataRequests = void 0;
        this.syncBlockSourceInfoRequests = void 0;
        // Track newly added sync blocks (resourceIds that were just subscribed to without cached data)
        this.newlyAddedSyncBlocks = void 0;
        // Keep track of the last flushed subscriptions to optimize cache flushing on document save
        this.lastFlushedSyncedBlocks = {};
        // Callback to notify when an unpublished sync block is detected
        this.onUnpublishedSyncBlockDetected = void 0;
        // Track if a flush operation is currently in progress
        this.isFlushInProgress = false;
        // Track if another flush is needed after the current one completes
        this.flushNeededAfterCurrent = false;
        // Track the setTimeout handle for queued flush so we can cancel it on destroy
        this.queuedFlushTimeout = void 0;
        // Track retry attempts for EntityNotFound errors (block may be in the process of being created)
        this.entityNotFoundRetryCount = new Map();
        this.entityNotFoundRetryTimers = new Map();
        // Pending cache deletion timers keyed by resourceId (gated by
        // `platform_synced_block_patch_14`). Cancelled when a subscriber re-attaches.
        this.pendingCacheDeletions = new Map();
        // Reschedule counter per resource — reset on actual deletion or re-subscribe.
        this.cacheDeletionRescheduleCounts = new Map();
        // Set by destroy() so in-flight timer callbacks can early-return.
        this.isDestroyed = false;
        this.fetchExperience = void 0;
        this.fetchSourceInfoExperience = void 0;
        this.saveExperience = void 0;
        this._subscriptionManager = void 0;
        this._providerFactoryManager = void 0;
        this._batchFetcher = void 0;
        this.dataProvider = dataProvider;
        this.viewMode = viewMode;
        this.syncBlockFetchDataRequests = new Map();
        this.syncBlockSourceInfoRequests = new Map();
        this.newlyAddedSyncBlocks = new Set();
        this._subscriptionManager = new (0, $axlAB.SyncBlockSubscriptionManager)({
            getDataProvider: ()=>this.dataProvider,
            getFromCache: (rid)=>this.getFromCache(rid),
            updateCache: (inst)=>this.updateCache(inst),
            deleteFromCache: (rid)=>this.deleteFromCache(rid),
            debouncedBatchedFetchSyncBlocks: (rid)=>this.debouncedBatchedFetchSyncBlocks(rid),
            fetchSyncBlockSourceInfo: (rid)=>this.fetchSyncBlockSourceInfo(rid),
            getFireAnalyticsEvent: ()=>this.fireAnalyticsEvent,
            markCacheDirty: ()=>{
                this.isCacheDirty = true;
            },
            // Delegate cache lifecycle to the store manager so guards can be
            // checked atomically (gated by `platform_synced_block_patch_14`).
            scheduleCacheDeletion: (rid)=>this.scheduleCacheDeletion(rid),
            cancelPendingCacheDeletion: (rid)=>this.cancelPendingCacheDeletion(rid)
        });
        this._providerFactoryManager = new (0, $cTANx.SyncBlockProviderFactoryManager)({
            getDataProvider: ()=>this.dataProvider,
            getFromCache: (rid)=>this.getFromCache(rid),
            getFireAnalyticsEvent: ()=>this.fireAnalyticsEvent
        });
        this._batchFetcher = new (0, $dyHCj.SyncBlockBatchFetcher)({
            getSubscriptions: ()=>this._subscriptionManager.getSubscriptions(),
            fetchSyncBlocksData: (nodes)=>this.fetchSyncBlocksData(nodes),
            getFireAnalyticsEvent: ()=>this.fireAnalyticsEvent,
            // EDITOR-7860: skip + re-queue fetches while not ready / torn down.
            isProviderReady: ()=>this.hasDataProvider()
        });
        // The provider might have SSR data cache already set, so we need to update the cache in session memory storage
        this.setSSRDataInSessionCache(this.dataProvider?.getNodeDataCacheKeys());
    }
}
module.exports["ReferenceSyncBlockStoreManager"] = $bf9ff2ea047058dc$export$fb04276dca31302e;

});

parcelRegister("4wATI", function(module, exports) {

var $f8eu7 = parcelRequire("f8eu7");


var $awHlv = parcelRequire("awHlv");

const $165aef3c3dcb8be4$export$dcc459f28c1cd2fd = (oldResult, newResult)=>{
    // if the old result has no data, we simply return the new result
    if (!oldResult.data) return newResult;
    else if (!newResult.data) {
        // return the old result if there was an error, e.g. network error, but not if not found or forbidden
        if (newResult.error?.type === (0, $awHlv.SyncBlockError).NotFound || newResult.error?.type === (0, $awHlv.SyncBlockError).Forbidden) return newResult;
        else return oldResult;
    }
    // otherwise, we merge the two results, preserving the sourceURL and sourceTitle from the old result if it exists
    return {
        ...newResult,
        data: {
            ...newResult.data,
            sourceURL: newResult.data?.sourceURL || oldResult.data?.sourceURL || undefined,
            sourceTitle: newResult.data?.sourceTitle || oldResult.data?.sourceTitle || undefined,
            sourceSubType: $165aef3c3dcb8be4$var$mergeSubType(oldResult, newResult),
            onSameDocument: newResult.data?.onSameDocument || oldResult.data?.onSameDocument || undefined,
            issueType: newResult.data?.issueType || oldResult.data?.issueType || undefined
        }
    };
};
const $165aef3c3dcb8be4$var$mergeSubType = (oldResult, newResult)=>{
    // for classic pages, subType is 'null'
    if (newResult.data?.sourceSubType !== undefined) return newResult.data.sourceSubType;
    if (newResult.data?.sourceAri) // for blogposts, subType is always undefined
    try {
        const { type: pageType } = (0, $f8eu7.getPageIdAndTypeFromConfluencePageAri)({
            ari: newResult.data?.sourceAri
        });
        if (pageType === 'blogpost') return newResult.data?.sourceSubType;
    } catch  {}
    return oldResult.data?.sourceSubType;
};
module.exports["resolveSyncBlockInstance"] = $165aef3c3dcb8be4$export$dcc459f28c1cd2fd;

});

parcelRegister("dyHCj", function(module, exports) {

var $2P8Ax = parcelRequire("2P8Ax");


var $hWRJP = parcelRequire("hWRJP");


var $dh538 = parcelRequire("dh538");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $gtauf = parcelRequire("gtauf");

class $f5bf878eca9bbfe8$export$7d827e0357659116 {
    queueFetch(resourceId) {
        const subscriptions = this.deps.getSubscriptions();
        if (subscriptions.has(resourceId) && Object.keys(subscriptions.get(resourceId) || {}).length > 0) {
            this.pendingFetchRequests.add(resourceId);
            this.scheduledBatchFetch();
        } else this.pendingFetchRequests.delete(resourceId);
    }
    /**
   * Returns true if a batched fetch is queued or in flight for `resourceId`.
   * Used by cache deletion guards to prevent deleting while a fetch is
   * about to populate the entry.
   */ hasPendingFetch(resourceId) {
        return this.pendingFetchRequests.has(resourceId) || this.inFlightFetches.has(resourceId);
    }
    cancel() {
        this.scheduledBatchFetch.cancel();
    }
    clearPending() {
        this.pendingFetchRequests.clear();
    }
    destroy() {
        this.isDestroyed = true;
        this.cancel();
        this.clearPending();
        // Clear in-flight tracking to prevent stale entries after teardown.
        this.inFlightFetches.clear();
    }
    constructor(deps){
        this.deps = deps;
        this.pendingFetchRequests = new Set();
        // Tracks resourceIds whose batched fetch is in flight (after RAF drains
        // pendingFetchRequests, before the promise settles). Ensures
        // `hasPendingFetch` remains true during the network window.
        this.inFlightFetches = new Set();
        this.isDestroyed = false;
        this.scheduledBatchFetch = void 0;
        this.scheduledBatchFetch = (0, $2P8Ax.default)(()=>{
            if (this.pendingFetchRequests.size === 0) return;
            // EDITOR-7860: not ready — skip and leave resourceIds queued for the
            // next batch once the provider resolves. Gate-off is unchanged (the
            // readiness check is nested under the gate so it is not consulted when
            // the gate is off, and `fg()` stays a standalone condition so gate
            // exposure is still tracked — satisfies @atlaskit/platform/no-preconditioning).
            if ((0, $dh538.fg)('platform_editor_blocks_patch_3')) {
                if (this.deps.isProviderReady && !this.deps.isProviderReady()) return;
            }
            const resourceIds = Array.from(this.pendingFetchRequests);
            const syncBlockNodes = resourceIds.map((resId)=>{
                const subscriptions = this.deps.getSubscriptions().get(resId) || {};
                const firstLocalId = Object.keys(subscriptions)[0] || '';
                return (0, $gtauf.createSyncBlockNode)(firstLocalId, resId);
            });
            this.pendingFetchRequests.clear();
            // Track in-flight before the fetch so guards remain positive.
            resourceIds.forEach((resId)=>this.inFlightFetches.add(resId));
            this.deps.fetchSyncBlocksData(syncBlockNodes).catch((error)=>{
                // EDITOR-7860: benign not-ready throw — re-queue for retry and emit
                // nothing (no analytics, no exception-tracker noise). Checked before
                // `logException` so the benign case stays silent. Re-schedule so the
                // re-queued IDs are retried on the next frame even if no further
                // `queueFetch()` arrives. Gate-off behaviour is unchanged.
                if ((0, $awHlv.isProviderNotReadyError)(error) && (0, $dh538.fg)('platform_editor_blocks_patch_3')) {
                    resourceIds.forEach((resId)=>this.pendingFetchRequests.add(resId));
                    if (!this.isDestroyed) this.scheduledBatchFetch();
                    return;
                }
                (0, $hWRJP.logException)(error, {
                    location: 'editor-synced-block-provider/syncBlockBatchFetcher/batchedFetchSyncBlocks'
                });
                const attribution = (0, $cFpEg.buildFetchErrorAttribution)((0, $dh538.fg)('platform_editor_blocks_patch_3'), error.message);
                resourceIds.forEach((resId)=>{
                    this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)(error.message, resId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resId), attribution));
                });
            }).finally(()=>{
                // If the fetcher was destroyed while the request was in flight,
                // skip cleanup — `destroy()` already cleared `inFlightFetches`
                // and there's nothing observable to update.
                if (this.isDestroyed) return;
                // Clear in-flight tracking once the fetch settles.
                resourceIds.forEach((resId)=>this.inFlightFetches.delete(resId));
            });
        });
    }
}
module.exports["SyncBlockBatchFetcher"] = $f5bf878eca9bbfe8$export$7d827e0357659116;

});

parcelRegister("bBz3A", function(module, exports) {
/**
 * In-memory session cache for sync block data with size-based LRU eviction.
 *
 * Backed by a plain Map so that potentially private ADF content is never
 * written to any browser-persistent storage (sessionStorage, localStorage,
 * IndexedDB). The module-level singleton survives SPA transitions (no full
 * page reload) and is naturally cleared on hard navigation or tab close.
 *
 * Uses JavaScript Map's insertion-order guarantee to implement LRU:
 * on every read or write the accessed entry is moved to the end of the
 * iteration order; when total cached size exceeds `maxSize`, the oldest
 * (least-recently-used) entries are evicted first.
 */ class $657a090a5274b259$export$75f7f86498dcaabe {
    /**
   * Retrieves a cached value by key.
   *
   * **Side-effect:** promotes the entry to the most-recently-used
   * position by re-inserting it at the end of the underlying Map's
   * iteration order.
   */ getItem(key) {
        const value = this.store.get(key);
        if (value === undefined) return null;
        this.store.delete(key);
        this.store.set(key, value);
        return value;
    }
    setItem(key, value) {
        const existing = this.store.get(key);
        if (existing !== undefined) {
            this.currentSize -= existing.length;
            this.store.delete(key);
        }
        this.store.set(key, value);
        this.currentSize += value.length;
        while(this.currentSize > this.maxSize && this.store.size > 1){
            const oldestKey = this.store.keys().next().value;
            if (oldestKey !== undefined) {
                const oldestValue = this.store.get(oldestKey);
                if (oldestValue !== undefined) this.currentSize -= oldestValue.length;
                this.store.delete(oldestKey);
            }
        }
    }
    removeItem(key) {
        const value = this.store.get(key);
        if (value !== undefined) {
            this.currentSize -= value.length;
            this.store.delete(key);
        }
    }
    /**
   * Removes all entries from the cache and resets the tracked size to zero.
   * Useful for cleaning up the singleton on SPA navigation boundaries.
   */ clear() {
        this.store.clear();
        this.currentSize = 0;
    }
    constructor(maxSize = 5242880){
        this.store = new Map();
        this.currentSize = 0;
        /**
     * Maximum total size of all cached values, measured in **UTF-16 code
     * units** (i.e. `String.prototype.length`), not bytes.  For ASCII-only
     * content the two are equivalent; for content with characters outside
     * the BMP each surrogate pair counts as 2.
     */ this.maxSize = void 0;
        this.maxSize = maxSize;
    }
}
const $657a090a5274b259$export$b811313deafee9ed = new $657a090a5274b259$export$75f7f86498dcaabe();
module.exports["syncBlockInMemorySessionCache"] = $657a090a5274b259$export$b811313deafee9ed;

});

parcelRegister("cTANx", function(module, exports) {

var $hWRJP = parcelRequire("hWRJP");


var $4FxUL = parcelRequire("4FxUL");


var $dh538 = parcelRequire("dh538");


var $cFpEg = parcelRequire("cFpEg");


var $47N43 = parcelRequire("47N43");


var $gtauf = parcelRequire("gtauf");

class $acb948bac57fc60c$export$3bfff6c128de82c9 {
    getProviderFactory(resourceId) {
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider) {
            const error = new Error('Data provider not set');
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockProviderFactoryManager'
            });
            this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)(error.message, resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId), (0, $cFpEg.buildFetchErrorAttribution)((0, $dh538.fg)('platform_editor_blocks_patch_3'), error.message)));
            return undefined;
        }
        const { parentDataProviders: parentDataProviders, providerCreator: providerCreator } = dataProvider.getSyncedBlockRendererProviderOptions();
        let providerFactory = this.providerFactories.get(resourceId);
        if (!providerFactory) {
            providerFactory = (0, $4FxUL.default).create({
                mentionProvider: parentDataProviders?.mentionProvider,
                profilecardProvider: parentDataProviders?.profilecardProvider,
                taskDecisionProvider: parentDataProviders?.taskDecisionProvider
            });
            this.providerFactories.set(resourceId, providerFactory);
        } else {
            if (parentDataProviders?.mentionProvider) providerFactory.setProvider('mentionProvider', parentDataProviders?.mentionProvider);
            if (parentDataProviders?.profilecardProvider) providerFactory.setProvider('profilecardProvider', parentDataProviders?.profilecardProvider);
            if (parentDataProviders?.taskDecisionProvider) providerFactory.setProvider('taskDecisionProvider', parentDataProviders?.taskDecisionProvider);
        }
        if (providerCreator) try {
            this.retrieveDynamicProviders(resourceId, providerFactory, providerCreator);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockProviderFactoryManager'
            });
            this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)(error.message, resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId), (0, $cFpEg.buildFetchErrorAttribution)((0, $dh538.fg)('platform_editor_blocks_patch_3'), error.message)));
        }
        return providerFactory;
    }
    getSSRProviders(resourceId) {
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider) return null;
        const { providerCreator: providerCreator } = dataProvider.getSyncedBlockRendererProviderOptions();
        if (!providerCreator?.createSSRMediaProvider) return null;
        const parsedResourceId = (0, $47N43.parseResourceId)(resourceId);
        if (!parsedResourceId) return null;
        let { contentId: contentId, product: contentProduct } = parsedResourceId;
        const syncBlock = this.deps.getFromCache(resourceId);
        let contentAri = syncBlock?.data?.sourceAri || '';
        if (syncBlock?.data?.sourceAri && syncBlock.data.product) {
            const parentInfo = dataProvider.retrieveSyncBlockParentInfo(syncBlock.data.sourceAri, syncBlock.data.product);
            if (parentInfo) {
                contentId = parentInfo.contentId;
                contentProduct = parentInfo.contentProduct;
                contentAri = parentInfo.contentAri;
            }
        }
        try {
            const mediaProvider = providerCreator.createSSRMediaProvider({
                contentAri: contentAri,
                contentId: contentId,
                contentProduct: contentProduct
            });
            if (mediaProvider) return {
                media: mediaProvider
            };
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockProviderFactoryManager'
            });
        }
        return null;
    }
    deleteFactory(resourceId) {
        this.providerFactories.delete(resourceId);
    }
    destroy() {
        this.providerFactories.forEach((pf)=>pf.destroy());
        this.providerFactories.clear();
    }
    retrieveDynamicProviders(resourceId, providerFactory, providerCreator) {
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider) throw new Error('Data provider not set');
        const hasMediaProvider = providerFactory.hasProvider('mediaProvider');
        const hasEmojiProvider = providerFactory.hasProvider('emojiProvider');
        const hasCardProvider = providerFactory.hasProvider('cardProvider');
        if (hasMediaProvider && hasEmojiProvider && hasCardProvider) return;
        const syncBlock = this.deps.getFromCache(resourceId);
        if (!syncBlock?.data) return;
        if (!syncBlock.data.sourceAri || !syncBlock.data.product) {
            this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)('Sync block source ari or product not found', resourceId, // Prefer cached product when available; fall back to parsing resourceId.
            syncBlock.data.product ?? (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId), (0, $cFpEg.buildFetchErrorAttribution)((0, $dh538.fg)('platform_editor_blocks_patch_3'), 'Sync block source ari or product not found')));
            return;
        }
        const parentInfo = dataProvider.retrieveSyncBlockParentInfo(syncBlock.data.sourceAri, syncBlock.data.product);
        if (!parentInfo) throw new Error('Unable to retrieve sync block parent info');
        const { contentAri: contentAri, contentId: contentId, contentProduct: contentProduct } = parentInfo;
        if (!hasMediaProvider && providerCreator.createMediaProvider && contentId && contentProduct) {
            const mediaProvider = providerCreator.createMediaProvider({
                contentAri: contentAri,
                contentProduct: contentProduct,
                contentId: contentId
            });
            if (mediaProvider) providerFactory.setProvider('mediaProvider', mediaProvider);
        }
        if (!hasEmojiProvider && providerCreator.createEmojiProvider && contentId && contentProduct) {
            const emojiProvider = providerCreator.createEmojiProvider({
                contentAri: contentAri,
                contentProduct: contentProduct,
                contentId: contentId
            });
            if (emojiProvider) providerFactory.setProvider('emojiProvider', emojiProvider);
        }
        if (!hasCardProvider && providerCreator.createSmartLinkProvider) {
            const smartLinkProvider = providerCreator.createSmartLinkProvider();
            if (smartLinkProvider) providerFactory.setProvider('cardProvider', smartLinkProvider);
        }
    }
    constructor(deps){
        this.deps = deps;
        this.providerFactories = new Map();
    }
}
module.exports["SyncBlockProviderFactoryManager"] = $acb948bac57fc60c$export$3bfff6c128de82c9;

});

parcelRegister("axlAB", function(module, exports) {

var $hWRJP = parcelRequire("hWRJP");


var $dh538 = parcelRequire("dh538");


var $cFpEg = parcelRequire("cFpEg");


var $4wATI = parcelRequire("4wATI");


var $gtauf = parcelRequire("gtauf");

class $e3afe1feb1dd429f$export$200c87d47b3d6e17 {
    // EDITOR-7861: higher ceiling lets transient WS-gateway drops self-heal
    // before a terminal failure is surfaced.
    getMaxRetryAttempts() {
        return (0, $dh538.fg)('platform_editor_blocks_patch_3') ? $e3afe1feb1dd429f$export$200c87d47b3d6e17.MAX_RETRY_ATTEMPTS_HARDENED : $e3afe1feb1dd429f$export$200c87d47b3d6e17.MAX_RETRY_ATTEMPTS;
    }
    // Backoff delay for the given attempt.
    // Gate OFF: pure exponential (1s, 2s, 4s, 8s, 16s).
    // Gate ON (EDITOR-7861): exponential capped at MAX_RETRY_DELAY_MS with equal
    // jitter (capped/2 + random*capped/2) — de-synchronises simultaneous
    // reconnects while guaranteeing a non-zero delay (full jitter could hit 0).
    getReconnectionDelay(attempts) {
        const exponential = $e3afe1feb1dd429f$export$200c87d47b3d6e17.INITIAL_RETRY_DELAY_MS * Math.pow($e3afe1feb1dd429f$export$200c87d47b3d6e17.RETRY_BACKOFF_MULTIPLIER, attempts);
        if (!(0, $dh538.fg)('platform_editor_blocks_patch_3')) return exponential;
        const half = Math.min(exponential, $e3afe1feb1dd429f$export$200c87d47b3d6e17.MAX_RETRY_DELAY_MS) / 2;
        return Math.round(half + Math.random() * half);
    }
    /**
   * Returns the subscriptions map. Used by external consumers (e.g. batch fetcher, flush)
   * that need to read the current subscription state.
   */ getSubscriptions() {
        return this.subscriptions;
    }
    setRealTimeSubscriptionsEnabled(enabled) {
        if (this.useRealTimeSubscriptions === enabled) return;
        this.useRealTimeSubscriptions = enabled;
        if (enabled) this.setupSubscriptionsForAllBlocks();
        else this.cleanupAll();
    }
    isRealTimeSubscriptionsEnabled() {
        return this.useRealTimeSubscriptions;
    }
    getSubscribedResourceIds() {
        return Array.from(this.subscriptions.keys());
    }
    onSubscriptionsChanged(listener) {
        this.subscriptionChangeListeners.add(listener);
        return ()=>{
            this.subscriptionChangeListeners.delete(listener);
        };
    }
    notifySubscriptionChangeListeners() {
        this.subscriptionChangeListeners.forEach((listener)=>{
            try {
                listener();
            } catch (error) {
                (0, $hWRJP.logException)(error, {
                    location: 'editor-synced-block-provider/syncBlockSubscriptionManager/notifySubscriptionChangeListeners'
                });
                this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)(error.message, undefined, undefined, (0, $cFpEg.buildFetchErrorAttribution)((0, $dh538.fg)('platform_editor_blocks_patch_3'), error.message)));
            }
        });
    }
    handleSubscriptionUpdate(syncBlockInstance) {
        if (!syncBlockInstance.resourceId) return;
        const existing = this.deps.getFromCache(syncBlockInstance.resourceId);
        const resolved = existing ? (0, $4wATI.resolveSyncBlockInstance)(existing, syncBlockInstance) : syncBlockInstance;
        this.deps.updateCache(resolved);
        if (!syncBlockInstance.error) this.deps.fetchSyncBlockSourceInfo(resolved.resourceId);
    }
    subscribeToSyncBlock(resourceId, localId, callback) {
        // Cancel any pending cache deletion for this resourceId.
        // This handles the case where a block is moved - the old component unmounts
        // (scheduling deletion) but the new component mounts and subscribes before
        // the deletion timeout fires.
        //
        // Under the flag, cache deletion is owned by the store manager.
        // With the flag off, the legacy 1s timer path is preserved.
        const pendingDeletion = this.pendingCacheDeletions.get(resourceId);
        if ((0, $dh538.fg)('platform_synced_block_patch_14')) this.deps.cancelPendingCacheDeletion(resourceId);
        else if (pendingDeletion) {
            clearTimeout(pendingDeletion);
            this.pendingCacheDeletions.delete(resourceId);
        }
        // add to subscriptions map
        const resourceSubscriptions = this.subscriptions.get(resourceId) || {};
        const isNewResourceSubscription = Object.keys(resourceSubscriptions).length === 0;
        this.subscriptions.set(resourceId, {
            ...resourceSubscriptions,
            [localId]: callback
        });
        // New subscription means new reference synced block is added to the document
        this.deps.markCacheDirty();
        // Notify listeners if this is a new resource subscription
        if (isNewResourceSubscription) this.notifySubscriptionChangeListeners();
        const cachedData = this.deps.getFromCache(resourceId);
        if (cachedData) callback(cachedData);
        else this.deps.debouncedBatchedFetchSyncBlocks(resourceId);
        // Set up GraphQL subscription if real-time subscriptions are enabled
        if (this.shouldUseRealTime()) this.setupSubscription(resourceId);
        return ()=>{
            const resourceSubscriptions = this.subscriptions.get(resourceId);
            if (resourceSubscriptions) {
                // Unsubscription means a reference synced block is removed from the document
                this.deps.markCacheDirty();
                delete resourceSubscriptions[localId];
                const remainingIds = Object.keys(resourceSubscriptions);
                if (remainingIds.length === 0) {
                    this.subscriptions.delete(resourceId);
                    // Clean up GraphQL subscription when no more local subscribers
                    this.cleanupSubscription(resourceId);
                    // Notify listeners that subscription was removed
                    this.notifySubscriptionChangeListeners();
                    // Under the flag, delegate cache deletion to the store manager
                    // which uses a 30s grace period with guard re-checks.
                    if ((0, $dh538.fg)('platform_synced_block_patch_14')) this.deps.scheduleCacheDeletion(resourceId);
                    else {
                        // Legacy path (unchanged): delay cache deletion to handle
                        // block moves (unmount/remount). When a block is moved, the
                        // old component unmounts before the new one mounts. By
                        // delaying deletion, we give the new component time to
                        // subscribe and cancel this pending deletion, preserving
                        // the cached data.
                        // TODO: EDITOR-4152 - Rework this logic (superseded by
                        // `platform_synced_block_patch_14`).
                        const deletionTimeout = setTimeout(()=>{
                            const hasSubscribers = this.subscriptions.has(resourceId);
                            // Only delete if still no subscribers (wasn't re-subscribed)
                            if (!hasSubscribers) this.deps.deleteFromCache(resourceId);
                            this.pendingCacheDeletions.delete(resourceId);
                        }, 1000);
                        this.pendingCacheDeletions.set(resourceId, deletionTimeout);
                    }
                } else this.subscriptions.set(resourceId, resourceSubscriptions);
            }
        };
    }
    subscribeToSourceTitle(node, callback) {
        // check node is a sync block, as we only support sync block subscriptions
        if (node.type.name !== 'syncBlock') return ()=>{};
        const { resourceId: resourceId, localId: localId } = node.attrs;
        if (!localId || !resourceId) return ()=>{};
        const cachedData = this.deps.getFromCache(resourceId);
        if (cachedData?.data?.sourceTitle) callback(cachedData.data.sourceTitle);
        // add to subscriptions map
        const resourceSubscriptions = this.titleSubscriptions.get(resourceId) || {};
        this.titleSubscriptions.set(resourceId, {
            ...resourceSubscriptions,
            [localId]: callback
        });
        return ()=>{
            const resourceSubscriptions = this.titleSubscriptions.get(resourceId);
            if (resourceSubscriptions) {
                delete resourceSubscriptions[localId];
                if (Object.keys(resourceSubscriptions).length === 0) this.titleSubscriptions.delete(resourceId);
                else this.titleSubscriptions.set(resourceId, resourceSubscriptions);
            }
        };
    }
    updateSourceTitleSubscriptions(resourceId, title) {
        const callbacks = this.titleSubscriptions.get(resourceId);
        if (callbacks) Object.values(callbacks).forEach((callback)=>{
            callback(title);
        });
    }
    /**
   * Notifies all subscription callbacks for a given resource ID with the provided sync block instance.
   */ notifySubscriptionCallbacks(resourceId, syncBlock) {
        const callbacks = this.subscriptions.get(resourceId);
        if (callbacks) Object.values(callbacks).forEach((callback)=>{
            callback(syncBlock);
        });
    }
    setupSubscription(resourceId) {
        if (this.graphqlSubscriptions.has(resourceId)) return;
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider?.subscribeToBlockUpdates) return;
        const unsubscribe = dataProvider.subscribeToBlockUpdates(resourceId, (syncBlockInstance)=>{
            this.handleGraphQLUpdate(syncBlockInstance);
        }, (error)=>{
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockSubscriptionManager/graphql-subscription'
            });
            // EDITOR-7861: a single socket drop is usually transient and
            // recovers on reconnect, so under the gate we don't fire a
            // user-facing error here — it's only surfaced on exhaustion (see
            // scheduleReconnection). Gate OFF keeps the legacy fire-on-drop.
            // This branch only runs when the gate is OFF, so buildFetchErrorAttribution
            // would return undefined; the structured attribution (EDITOR-7862) is therefore
            // applied at the gate-ON exhaustion site in scheduleReconnection instead.
            if (!(0, $dh538.fg)('platform_editor_blocks_patch_3')) this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)(error.message, resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId)));
            this.handleSubscriptionTerminated(resourceId);
        }, ()=>{
            this.handleSubscriptionTerminated(resourceId);
        });
        if (unsubscribe) this.graphqlSubscriptions.set(resourceId, unsubscribe);
    }
    /**
   * Handles subscription termination (complete or error) by cleaning up the
   * stale entry and scheduling a reconnection with exponential backoff.
   */ handleSubscriptionTerminated(resourceId) {
        // Remove the stale subscription entry so setupSubscription won't early-return
        this.graphqlSubscriptions.delete(resourceId);
        // Guard against duplicate calls (graphql-ws can fire both error and complete)
        if (this.pendingRetries.has(resourceId)) return;
        // Only reconnect if there are still active subscribers for this resource
        if (this.subscriptions.has(resourceId) && this.shouldUseRealTime()) this.scheduleReconnection(resourceId);
    }
    // Schedules a reconnection with backoff (see getMaxRetryAttempts /
    // getReconnectionDelay for the gated behaviour).
    scheduleReconnection(resourceId) {
        const attempts = this.retryAttempts.get(resourceId) ?? 0;
        const maxAttempts = this.getMaxRetryAttempts();
        if (attempts >= maxAttempts) {
            // Exhausted all attempts — the only place a WS drop surfaces as a
            // fetch error under the gate (EDITOR-7861).
            const errorMessage = `Subscription reconnection failed after ${attempts} attempts`;
            (0, $hWRJP.logException)(new Error(errorMessage), {
                location: 'editor-synced-block-provider/syncBlockSubscriptionManager/max-retries-exhausted'
            });
            this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)(errorMessage, resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId), (0, $cFpEg.buildFetchErrorAttribution)((0, $dh538.fg)('platform_editor_blocks_patch_3'), errorMessage)));
            return;
        }
        const delay = this.getReconnectionDelay(attempts);
        const timer = setTimeout(()=>{
            this.pendingRetries.delete(resourceId);
            // Only re-subscribe if still relevant
            if (this.subscriptions.has(resourceId) && this.shouldUseRealTime()) {
                this.setupSubscription(resourceId);
                // Only increment if the subscription was actually established
                // (setupSubscription may be a no-op if another code path already re-established it)
                if (this.graphqlSubscriptions.has(resourceId)) this.retryAttempts.set(resourceId, attempts + 1);
            } else // Conditions no longer met — clean up stale retry state
            this.retryAttempts.delete(resourceId);
        }, delay);
        this.pendingRetries.set(resourceId, timer);
    }
    /**
   * Resets the retry counter for a resource. Called when a successful
   * update is received, indicating the subscription is healthy.
   */ resetRetryCount(resourceId) {
        this.retryAttempts.delete(resourceId);
    }
    cancelPendingRetry(resourceId) {
        const timer = this.pendingRetries.get(resourceId);
        if (timer) {
            clearTimeout(timer);
            this.pendingRetries.delete(resourceId);
        }
    }
    cancelAllPendingRetries() {
        for (const timer of this.pendingRetries.values())clearTimeout(timer);
        this.pendingRetries.clear();
        this.retryAttempts.clear();
    }
    cleanupSubscription(resourceId) {
        const unsubscribe = this.graphqlSubscriptions.get(resourceId);
        if (unsubscribe) {
            unsubscribe();
            this.graphqlSubscriptions.delete(resourceId);
        }
        this.cancelPendingRetry(resourceId);
        this.retryAttempts.delete(resourceId);
    }
    setupSubscriptionsForAllBlocks() {
        for (const resourceId of this.subscriptions.keys())this.setupSubscription(resourceId);
    }
    cleanupAll() {
        for (const unsubscribe of this.graphqlSubscriptions.values())unsubscribe();
        this.graphqlSubscriptions.clear();
        this.cancelAllPendingRetries();
    }
    destroy() {
        this.cleanupAll();
        this.subscriptions.clear();
        this.titleSubscriptions.clear();
        this.subscriptionChangeListeners.clear();
        this.useRealTimeSubscriptions = false;
        // Clear any pending cache deletions
        for (const timeout of this.pendingCacheDeletions.values())clearTimeout(timeout);
        this.pendingCacheDeletions.clear();
    }
    shouldUseRealTime() {
        return this.useRealTimeSubscriptions;
    }
    handleGraphQLUpdate(syncBlockInstance) {
        if (!syncBlockInstance.resourceId) return;
        const existing = this.deps.getFromCache(syncBlockInstance.resourceId);
        const resolved = existing ? (0, $4wATI.resolveSyncBlockInstance)(existing, syncBlockInstance) : syncBlockInstance;
        this.deps.updateCache(resolved);
        if (!syncBlockInstance.error) {
            this.resetRetryCount(syncBlockInstance.resourceId);
            const callbacks = this.subscriptions.get(syncBlockInstance.resourceId);
            const localIds = callbacks ? Object.keys(callbacks) : [];
            localIds.forEach((localId)=>{
                this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchSuccessPayload)(syncBlockInstance.resourceId, localId, syncBlockInstance.data?.product ?? (0, $gtauf.getSourceProductFromResourceIdSafe)(syncBlockInstance.resourceId)));
            });
            this.deps.fetchSyncBlockSourceInfo(resolved.resourceId);
        } else {
            const errorMessage = syncBlockInstance.error?.reason || syncBlockInstance.error?.type;
            // Prefer the structured `type` (a `SyncBlockError` enum value) for classification
            // and fall back to the free-text `reason` so source-state/permission strings are
            // still bucketed (EDITOR-7862). The emitted free-text `error` attribute is unchanged.
            this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)(errorMessage, syncBlockInstance.resourceId, syncBlockInstance.data?.product ?? (0, $gtauf.getSourceProductFromResourceIdSafe)(syncBlockInstance.resourceId), (0, $cFpEg.buildFetchErrorAttribution)((0, $dh538.fg)('platform_editor_blocks_patch_3'), syncBlockInstance.error?.type || syncBlockInstance.error?.reason, syncBlockInstance.error?.statusCode)));
        }
    }
    constructor(deps){
        this.deps = deps;
        this.subscriptions = new Map();
        this.titleSubscriptions = new Map();
        this.graphqlSubscriptions = new Map();
        this.subscriptionChangeListeners = new Set();
        this.useRealTimeSubscriptions = false;
        // Track pending cache deletions to handle block moves (unmount/remount)
        // When a block is moved, the old component unmounts before the new one mounts,
        // causing the cache to be deleted prematurely. We delay deletion to allow
        // the new component to subscribe and cancel the pending deletion.
        this.pendingCacheDeletions = new Map();
        // backoff cap (gate ON)
        this.retryAttempts = new Map();
        this.pendingRetries = new Map();
    }
}
// Reconnection with exponential backoff.
$e3afe1feb1dd429f$export$200c87d47b3d6e17.INITIAL_RETRY_DELAY_MS = 1000;
$e3afe1feb1dd429f$export$200c87d47b3d6e17.RETRY_BACKOFF_MULTIPLIER = 2;
$e3afe1feb1dd429f$export$200c87d47b3d6e17.MAX_RETRY_ATTEMPTS = 5;
// legacy (gate OFF)
$e3afe1feb1dd429f$export$200c87d47b3d6e17.MAX_RETRY_ATTEMPTS_HARDENED = 8;
// gate ON (EDITOR-7861)
$e3afe1feb1dd429f$export$200c87d47b3d6e17.MAX_RETRY_DELAY_MS = 30000;
module.exports["SyncBlockSubscriptionManager"] = $e3afe1feb1dd429f$export$200c87d47b3d6e17;

});

parcelRegister("dBGrG", function(module, exports) {

var $hWRJP = parcelRequire("hWRJP");


var $dh538 = parcelRequire("dh538");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $QkKjT = parcelRequire("QkKjT");


var $gtauf = parcelRequire("gtauf");

/** Maximum time (ms) flush() will wait for in-flight block creations before proceeding. */ const $297b92badcfd6d6a$var$FLUSH_CREATION_AWAIT_TIMEOUT_MS = 1000;
/**
 * Window (ms) within which a repeated `syncedBlockDelete` emission for the same
 * resourceId is suppressed. The same logical removal can re-fire across
 * rebased/remote/redo transactions; a short window collapses those bursts to one
 * event while still allowing a genuine delete→recreate→delete later.
 */ const $297b92badcfd6d6a$var$DELETE_DEDUPE_WINDOW_MS = 5000;
class $297b92badcfd6d6a$export$9c6faa8962092f36 {
    /**
   * Register a callback to be invoked after flush() completes.
   * Used by the pm-plugin to dispatch a transaction so that
   * hasUnsavedBodiedSyncBlockChanges is recalculated in plugin state.
   */ registerFlushCompletionCallback(callback) {
        this.flushCompletionCallback = callback;
    }
    /**
   * Register a callback to be invoked when flush() timed out waiting for a
   * pending block creation and that creation subsequently completes. The
   * callback should trigger a deferred flush to persist the content that
   * was skipped due to the timeout. See EDITOR-7112.
   */ registerPostCreationFlushCallback(callback) {
        this.postCreationFlushCallback = callback;
    }
    setFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
        this.createExperience = (0, $QkKjT.getCreateSourceExperience)(fireAnalyticsEvent);
        this.saveExperience = (0, $QkKjT.getSaveSourceExperience)(fireAnalyticsEvent);
        this.deleteExperience = (0, $QkKjT.getDeleteSourceExperience)(fireAnalyticsEvent);
        this.fetchSourceInfoExperience = (0, $QkKjT.getFetchSourceInfoExperience)(fireAnalyticsEvent);
    }
    isSourceBlock(node) {
        return node.type.name === 'bodiedSyncBlock';
    }
    /**
   * Add/update a sync block node to/from the local cache
   * @param syncBlockNode - The sync block node to update
   */ updateSyncBlockData(syncBlockNode, isRemote) {
        try {
            if (this.viewMode === 'view') return false;
            if (!this.isSourceBlock(syncBlockNode)) throw new Error('Invalid sync block node type provided for updateSyncBlockData');
            const { localId: localId, resourceId: resourceId } = syncBlockNode.attrs;
            if (!localId || !resourceId) {
                // Identifiers not populated yet: benign timing case, skip as a no-op.
                if ((0, $dh538.fg)('platform_editor_blocks_patch_4')) return false;
                throw new Error('Local ID or resource ID is not set');
            }
            const cachedBlock = this.syncBlockCache.get(resourceId);
            // Fast path: if the PM content fragment hasn't changed, skip serialization entirely
            // Fragment.eq() leverages ProseMirror's structural sharing for O(1) comparison
            if (cachedBlock?.contentFragment?.eq(syncBlockNode.content)) return true;
            const syncBlockData = (0, $gtauf.convertSyncBlockPMNodeToSyncBlockData)(syncBlockNode);
            if (cachedBlock && !isRemote) this.hasReceivedContentChange = true;
            const isDirty = !isRemote || !cachedBlock; // if the change is not remote, or the block is not in the cache yet, it's dirty
            this.syncBlockCache.set(resourceId, {
                ...syncBlockData,
                isDirty: isDirty,
                // if the change is from remote, it's not dirty
                contentFragment: syncBlockNode.content,
                status: cachedBlock?.status
            });
            return true;
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            // We can derive the product from `syncBlockNode.attrs.resourceId` even though
            // the variable wasn't destructured (the destructuring step itself may have thrown).
            this.fireAnalyticsEvent?.((0, $cFpEg.updateCacheErrorPayload)(error.message, syncBlockNode?.attrs?.resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(syncBlockNode?.attrs?.resourceId)));
            return false;
        }
    }
    /**
   * Save content of bodiedSyncBlock nodes in local cache to backend
   *
   * @returns true if saving all nodes successfully, false if fail to save some/all nodes
   */ async flush() {
        try {
            if (this.viewMode === 'view') return true;
            // Wait (up to FLUSH_CREATION_AWAIT_TIMEOUT_MS) for any in-flight
            // block creations to complete before iterating the cache. Without
            // this, blocks created from existing content are skipped
            // (isPendingCreation check below) and if no further edits are made,
            // no subsequent flush is triggered — causing references to show an
            // "unpublished" error.
            // If the timeout expires, any block whose creation is still
            // in-flight is recorded in `creationsTimedOutDuringFlush` so that
            // `commitPendingCreation()` can trigger a follow-up flush once that
            // specific creation completes.
            // See EDITOR-7112.
            if (this.pendingCreationPromises.size > 0) {
                let timedOut = false;
                let timeoutId;
                const timeout = new Promise((resolve)=>{
                    timeoutId = setTimeout(()=>{
                        timedOut = true;
                        resolve();
                    }, $297b92badcfd6d6a$var$FLUSH_CREATION_AWAIT_TIMEOUT_MS);
                });
                await Promise.race([
                    Promise.all(this.pendingCreationPromises.values()),
                    timeout
                ]);
                if (timeoutId !== undefined) clearTimeout(timeoutId);
                if (timedOut) // Record every still-in-flight creation so each late
                // completion is tracked independently.
                for (const resourceId of this.pendingCreationPromises.keys())this.creationsTimedOutDuringFlush.add(resourceId);
            }
            const bodiedSyncBlockNodes = [];
            const bodiedSyncBlockData = [];
            Array.from(this.syncBlockCache.values()).forEach((syncBlockData)=>{
                // Don't flush nodes that
                // - are waiting to be deleted to avoid nodes being re-created
                // - haven't been updated since we last flushed
                // - are still pending BE creation
                if (!syncBlockData.pendingDeletion && syncBlockData.isDirty && !this.isPendingCreation(syncBlockData.resourceId)) {
                    bodiedSyncBlockNodes.push({
                        type: 'bodiedSyncBlock',
                        attrs: {
                            localId: syncBlockData.blockInstanceId,
                            resourceId: syncBlockData.resourceId
                        }
                    });
                    // reset isDirty early to prevent race condition
                    // There is a race condition where if a user makes changes to a source sync block
                    // on a live page and the source sync block is being saved while the user
                    // is still making changes, the new changes might not be saved if they all happen
                    // exactly at a time when the writeNodesData is being executed asynchronously.
                    syncBlockData.isDirty = false;
                    // When flushing, set status to 'active' so the block is published
                    const dataToFlush = {
                        ...syncBlockData,
                        status: 'active'
                    };
                    bodiedSyncBlockData.push(dataToFlush);
                }
            });
            if (bodiedSyncBlockNodes.length === 0) return Promise.resolve(true);
            if (!this.dataProvider) throw new Error('Data provider not set');
            this.saveExperience?.start({});
            const writeResults = await this.dataProvider.writeNodesData(bodiedSyncBlockNodes, bodiedSyncBlockData);
            writeResults.forEach((result)=>{
                // set isDirty to true for cases where it failed to save the sync block to the BE
                if (result.resourceId && result.error && result.error !== (0, $awHlv.SyncBlockError).NotFound) {
                    const cachedData = this.syncBlockCache.get(result.resourceId);
                    if (cachedData) cachedData.isDirty = true;
                }
            });
            if (writeResults.every((result)=>result.resourceId && !result.error)) {
                this.saveExperience?.success();
                writeResults.forEach((result)=>{
                    if (result.resourceId && !result.error) {
                        // Update cache with the status returned from the backend
                        const cachedData = this.syncBlockCache.get(result.resourceId);
                        if (cachedData && result.status) cachedData.status = result.status;
                        this.fireAnalyticsEvent?.((0, $cFpEg.updateSuccessPayload)(result.resourceId, false, (0, $gtauf.getSourceProductFromResourceIdSafe)(result.resourceId)));
                    }
                });
                return true;
            } else {
                this.saveExperience?.failure();
                const attributionEnabled = (0, $dh538.fg)('platform_editor_blocks_patch_3');
                writeResults.filter((result)=>!result.resourceId || result.error).forEach((result)=>{
                    this.fireAnalyticsEvent?.((0, $cFpEg.updateErrorPayload)(result.error || 'Failed to write data', result.resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(result.resourceId), (0, $cFpEg.buildErrorAttribution)(attributionEnabled, result.error, result.statusCode)));
                });
                return false;
            }
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            // Top-level flush failure is not tied to a single resourceId. There is no structured
            // SyncBlockError/status here, so the attribution `reason` falls back to `unknown`.
            this.fireAnalyticsEvent?.((0, $cFpEg.updateErrorPayload)(error.message, undefined, undefined, (0, $cFpEg.buildErrorAttribution)((0, $dh538.fg)('platform_editor_blocks_patch_3'))));
            return false;
        } finally{
            this.flushCompletionCallback?.();
        }
    }
    hasUnsavedChanges() {
        if (this.viewMode === 'view') return false;
        // Only track unsaved changes in source synced block for live pages
        // classic pages's draft don't publish synced block content to block service and the content itself is saved as part of the draft
        // classic page's publish flow will trigger a flush which only uses the isDirty flag to determine if there are unsaved changes
        if (!this.isLivePage) return false;
        return this.hasReceivedContentChange && Array.from(this.syncBlockCache.values()).some((syncBlockData)=>syncBlockData.isDirty);
    }
    isPendingCreation(resourceId) {
        return this.creationCompletionCallbacks.has(resourceId);
    }
    /**
   * Returns `true` when at least one sync block is waiting for its backend
   * creation call to complete. Used as a cheap pre-check in the decoration
   * rebuild path to avoid a full `doc.descendants()` walk when no creations
   * are in flight (see EDITOR-6930).
   */ hasPendingCreations() {
        return this.creationCompletionCallbacks.size > 0;
    }
    /**
   *  Fires callback to insert node (if creation is successful) and clears pending creation data
   * @param success
   */ commitPendingCreation(success, resourceId) {
        if (this.viewMode === 'view') return;
        const onCompletion = this.creationCompletionCallbacks.get(resourceId);
        if (onCompletion) {
            this.creationCompletionCallbacks.delete(resourceId);
            onCompletion(success);
            // If a previous flush() timed out waiting for this specific
            // creation, drop it from the tracking set regardless of outcome so
            // it does not leak. See EDITOR-7112.
            const wasTimedOut = this.creationsTimedOutDuringFlush.delete(resourceId);
            if (success) {
                // If creation is successful, set hasReceivedContentChange to true
                // to indicate that there are unsaved changes in the cache
                this.hasReceivedContentChange = true;
                // If flush() timed out waiting for this creation, notify the
                // plugin so it can trigger a deferred flush. See EDITOR-7112.
                if (wasTimedOut) this.postCreationFlushCallback?.();
            }
        } else this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)('creation complete callback missing', resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId)));
        if (success) {
            const sourceProduct = (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId);
            this.fireAnalyticsEvent?.((0, $cFpEg.createSuccessPayload)(resourceId || '', sourceProduct));
            // Operational create-success event with the join key.
            if ((0, $dh538.fg)('platform_editor_blocks_patch_4')) this.fireAnalyticsEvent?.((0, $cFpEg.createSuccessOperationalPayload)(resourceId || '', this.syncBlockCache.get(resourceId)?.blockInstanceId, sourceProduct));
        } else {
            // Delete the node from cache if fail to create so it's not flushed to BE
            this.syncBlockCache.delete(resourceId || '');
            this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)('Fail to create bodied sync block', resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId)));
        }
    }
    registerConfirmationCallback(callback) {
        this.confirmationCallback = callback;
        return ()=>{
            this.confirmationCallback = undefined;
        };
    }
    requireConfirmationBeforeDelete() {
        return !!this.confirmationCallback;
    }
    /**
   * @returns attributes for a new bodiedSyncBlock node
   */ generateBodiedSyncBlockAttrs() {
        if (!this.dataProvider) throw new Error('Data provider not set or source id not set');
        const { resourceId: resourceId, localId: localId } = this.dataProvider.generateResourceId();
        return {
            resourceId: resourceId,
            localId: localId
        };
    }
    /**
   * Create a bodiedSyncBlock node with empty content to backend
   * @param attrs attributes Ids of the node
   * @param node the ProseMirror node to cache
   * @param onCompletion callback invoked when creation completes
   */ createBodiedSyncBlockNode(attrs, node, onCompletion) {
        if (this.viewMode === 'view') return;
        const { resourceId: resourceId, localId: blockInstanceId } = attrs;
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            // add the node to the cache
            this.updateSyncBlockData(node, false);
            // Mark the block as unpublished in the cache so it can be cleaned up on cancel
            const cached = this.syncBlockCache.get(resourceId);
            if (cached) cached.status = 'unpublished';
            this.creationCompletionCallbacks.set(resourceId, onCompletion);
            this.createExperience?.start({});
            const creationPromise = this.dataProvider.createNodeData({
                content: [],
                blockInstanceId: blockInstanceId,
                resourceId: resourceId
            }).then((result)=>{
                const resourceId = result.resourceId || '';
                if (resourceId && !result.error) {
                    this.commitPendingCreation(true, resourceId);
                    this.createExperience?.success();
                } else {
                    this.commitPendingCreation(false, resourceId);
                    this.createExperience?.failure({
                        reason: result.error || 'Failed to create bodied sync block'
                    });
                    this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)(result.error || 'Failed to create bodied sync block', resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId), (0, $cFpEg.buildErrorAttribution)((0, $dh538.fg)('platform_editor_blocks_patch_3'), result.error, result.statusCode)));
                }
            }).catch((error)=>{
                this.commitPendingCreation(false, resourceId);
                (0, $hWRJP.logException)(error, {
                    location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
                });
                this.createExperience?.failure({
                    reason: error.message
                });
                this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)(error.message, resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId)));
            }).finally(()=>{
                this.pendingCreationPromises.delete(resourceId);
            });
            this.pendingCreationPromises.set(resourceId, creationPromise);
        } catch (error) {
            if (this.isPendingCreation(resourceId)) this.commitPendingCreation(false, resourceId);
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)(error.message, resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId)));
        }
    }
    /**
   * Drop dedupe entries older than {@link DELETE_DEDUPE_WINDOW_MS} so
   * `recentDeleteEmissions` stays bounded by the number of recent deletes.
   */ pruneRecentDeleteEmissions(now) {
        for (const [resourceId, emittedAt] of this.recentDeleteEmissions)if (now - emittedAt >= $297b92badcfd6d6a$var$DELETE_DEDUPE_WINDOW_MS) this.recentDeleteEmissions.delete(resourceId);
    }
    /**
   * Emit the `syncedBlockDelete` success event. Gate off: legacy payload. Gate
   * on: attaches `deletionReason`, `mechanism` and `blockInstanceId`, and
   * suppresses repeat emissions within {@link DELETE_DEDUPE_WINDOW_MS}. Must run
   * while the cache entry still exists so `blockInstanceId` is available.
   */ emitDeleteSuccess(resourceId, reason, mechanism) {
        const sourceProduct = (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId);
        if (!(0, $dh538.fg)('platform_editor_blocks_patch_4')) {
            this.fireAnalyticsEvent?.((0, $cFpEg.deleteSuccessPayload)(resourceId, sourceProduct));
            return;
        }
        const now = Date.now();
        const lastEmittedAt = this.recentDeleteEmissions.get(resourceId);
        if (lastEmittedAt !== undefined && now - lastEmittedAt < $297b92badcfd6d6a$var$DELETE_DEDUPE_WINDOW_MS) return; // duplicate emission for the same logical removal
        this.pruneRecentDeleteEmissions(now);
        this.recentDeleteEmissions.set(resourceId, now);
        const enrichment = {
            blockInstanceId: this.syncBlockCache.get(resourceId)?.blockInstanceId,
            deletionReason: reason,
            mechanism: mechanism
        };
        this.fireAnalyticsEvent?.((0, $cFpEg.deleteSuccessPayload)(resourceId, sourceProduct, enrichment));
    }
    async delete(syncBlockIds, onDelete, onDeleteCompleted, reason, mechanism) {
        try {
            if (this.viewMode === 'view') return false;
            if (!this.dataProvider) throw new Error('Data provider not set');
            syncBlockIds.forEach((Ids)=>{
                this.setPendingDeletion(Ids, true);
            });
            this.deleteExperience?.start({});
            const results = await this.dataProvider.deleteNodesData(syncBlockIds.map((attrs)=>attrs.resourceId), reason);
            let callback;
            const isDeleteSuccessful = results.every((result)=>result.success);
            onDeleteCompleted(isDeleteSuccessful);
            if (isDeleteSuccessful) {
                onDelete();
                // Emit before the cache entry is deleted below, so blockInstanceId
                // is still available to emitDeleteSuccess.
                results.forEach((result)=>{
                    this.emitDeleteSuccess(result.resourceId, reason, mechanism);
                });
                callback = (Ids)=>this.syncBlockCache.delete(Ids.resourceId);
                this.clearPendingDeletion();
                this.deleteExperience?.success();
            } else {
                callback = (Ids)=>{
                    this.setPendingDeletion(Ids, false);
                };
                this.deleteExperience?.failure();
                const attributionEnabled = (0, $dh538.fg)('platform_editor_blocks_patch_3');
                results.forEach((result)=>{
                    if (result.success) this.emitDeleteSuccess(result.resourceId, reason, mechanism);
                    else this.fireAnalyticsEvent?.((0, $cFpEg.deleteErrorPayload)(result.error || 'Failed to delete synced block', result.resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(result.resourceId), (0, $cFpEg.buildErrorAttribution)(attributionEnabled, result.error, result.statusCode)));
                });
            }
            syncBlockIds.forEach(callback);
            return isDeleteSuccessful;
        } catch (error) {
            // Thrown (non-result) failure — no structured SyncBlockError/status is available,
            // so the attribution `reason` falls back to `unknown` when the gate is on.
            const attribution = (0, $cFpEg.buildErrorAttribution)((0, $dh538.fg)('platform_editor_blocks_patch_3'));
            syncBlockIds.forEach((Ids)=>{
                this.setPendingDeletion(Ids, false);
                this.fireAnalyticsEvent?.((0, $cFpEg.deleteErrorPayload)(error.message, Ids.resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(Ids.resourceId), attribution));
            });
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            onDeleteCompleted(false);
            return false;
        }
    }
    isRetryingDeletion() {
        return !!this.deletionRetryInfo;
    }
    async retryDeletion() {
        if (this.viewMode === 'view') return Promise.resolve();
        if (!this.deletionRetryInfo) return Promise.resolve();
        const { syncBlockIds: syncBlockIds, onDelete: onDelete, onDeleteCompleted: onDeleteCompleted, deletionReason: deletionReason, mechanism: mechanism } = this.deletionRetryInfo;
        if (this.confirmationCallback) await this.delete(syncBlockIds, onDelete, onDeleteCompleted, deletionReason, mechanism);
    }
    clearPendingDeletion() {
        this.deletionRetryInfo?.destroyCallback();
        this.deletionRetryInfo = undefined;
    }
    /**
   * Fetches the current status of all source sync blocks in the cache from the backend
   * and updates the cache entries with the fetched status.
   * This is called on editor init so we know which blocks are 'unpublished' vs 'active'.
   */ async fetchAndCacheStatuses() {
        if (!this.dataProvider || this.syncBlockCache.size === 0) return;
        // Source blocks have plain UUID resourceIds, but fetchNodesData internally uses
        // generateBlockAriFromReference which expects reference-format resourceIds
        // (e.g. "confluence-page/pageId/uuid"). We convert source resourceIds to reference
        // format before fetching, and maintain a mapping back to original resourceIds
        // so we can update the correct cache entries.
        const sourceToReferenceMap = new Map();
        const syncBlockNodes = Array.from(this.syncBlockCache.entries()).map(([resourceId, data])=>{
            const referenceResourceId = this.dataProvider?.generateResourceIdForReference(resourceId) ?? resourceId;
            sourceToReferenceMap.set(referenceResourceId, resourceId);
            return {
                type: 'bodiedSyncBlock',
                attrs: {
                    localId: data.blockInstanceId,
                    resourceId: referenceResourceId
                }
            };
        });
        try {
            const results = await this.dataProvider.fetchNodesData(syncBlockNodes);
            for (const result of results){
                // Map the reference resourceId back to the source resourceId
                const sourceResourceId = sourceToReferenceMap.get(result.resourceId) ?? result.resourceId;
                const cached = this.syncBlockCache.get(sourceResourceId);
                if (cached && result.data?.status) cached.status = result.data.status;
            }
        } catch  {
        // If the fetch fails, statuses remain undefined.
        // This is acceptable — on cancel, blocks without a known status
        // will not be deleted (safe default).
        }
    }
    /**
   * Deletes all source sync blocks that have 'unpublished' status.
   * Used to clean up orphaned blocks when a user cancels editing without saving.
   * Blocks that were already saved (status 'active') are not affected.
   *
   * @returns true if all deletions succeeded, false otherwise
   */ discardUnpublishedBlocks() {
        const unpublishedBlockIds = Array.from(this.syncBlockCache.entries()).filter(([_, data])=>data.status === 'unpublished' && !data.pendingDeletion).map(([resourceId, data])=>({
                resourceId: resourceId,
                localId: data.blockInstanceId
            }));
        if (unpublishedBlockIds.length === 0) return Promise.resolve(true);
        return this.delete(unpublishedBlockIds, ()=>{}, // onDelete: no-op, document is being discarded
        ()=>{}, // onDeleteCompleted: no-op
        'source-block-unpublished', // Cancel/discard cleanup is code-initiated, not a direct user edit.
        'other');
    }
    /**
   * Deletes sync blocks with confirmation from the backend
   *
   * @param syncBlockIds - The sync block ids to delete
   * @param onDelete - The callback to delete sync block node from document
   * @param onDeleteCompleted - The callback for after the deletion is saved to BE (whether successful or not)
   * @param destroyCallback - The callback to clear any reference stored for deletion (regardless if deletion is completed or abort)
   */ async deleteSyncBlocksWithConfirmation(syncBlockIds, deletionReason, onDelete, onDeleteCompleted, destroyCallback, mechanism) {
        if (this.viewMode === 'view') return Promise.resolve();
        if (this.confirmationCallback) {
            const confirmed = await this.confirmationCallback(syncBlockIds, deletionReason);
            if (confirmed) {
                const isDeleteSuccessful = await this.delete(syncBlockIds, onDelete, onDeleteCompleted, deletionReason, mechanism);
                if (!isDeleteSuccessful) // If deletion failed, save deletion info for potential retry
                this.deletionRetryInfo = {
                    syncBlockIds: syncBlockIds,
                    onDelete: onDelete,
                    onDeleteCompleted: onDeleteCompleted,
                    destroyCallback: destroyCallback,
                    deletionReason: deletionReason,
                    mechanism: mechanism
                };
                else destroyCallback();
            } else destroyCallback();
        }
    }
    getSyncBlockSourceInfo(localId) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            this.fetchSourceInfoExperience?.start();
            return this.dataProvider.fetchSyncBlockSourceInfo(localId, undefined, undefined).then((sourceInfo)=>{
                if (!sourceInfo) this.fetchSourceInfoExperience?.failure({
                    reason: 'No source info returned'
                });
                else this.fetchSourceInfoExperience?.success();
                return sourceInfo;
            });
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message));
            return Promise.resolve(undefined);
        }
    }
    fetchReferences(resourceId) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            return this.dataProvider.fetchReferences(resourceId, true);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchReferencesErrorPayload)(error.message, resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId)));
            return Promise.resolve({
                error: (0, $awHlv.SyncBlockError).Errored
            });
        }
    }
    destroy() {
        this.syncBlockCache.clear();
        this.confirmationCallback = undefined;
        this.creationCompletionCallbacks.clear();
        this.flushCompletionCallback = undefined;
        this.postCreationFlushCallback = undefined;
        this.pendingCreationPromises.clear();
        this.creationsTimedOutDuringFlush.clear();
        this.recentDeleteEmissions.clear();
        this.dataProvider = undefined;
        this.saveExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.createExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.deleteExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchSourceInfoExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.clearPendingDeletion();
    }
    constructor(dataProvider, viewMode, isLivePage){
        this.viewMode = void 0;
        this.isLivePage = void 0;
        this.dataProvider = void 0;
        this.fireAnalyticsEvent = void 0;
        this.syncBlockCache = void 0;
        this.hasReceivedContentChange = false;
        this.confirmationCallback = void 0;
        this.deletionRetryInfo = void 0;
        this.creationCompletionCallbacks = void 0;
        this.flushCompletionCallback = void 0;
        this.postCreationFlushCallback = void 0;
        /**
     * Promises for in-flight block creations, keyed by resourceId.
     * `flush()` awaits these so that blocks created from existing content are
     * persisted even if no further edits trigger a subsequent flush.
     * See EDITOR-7112.
     */ this.pendingCreationPromises = new Map();
        /**
     * Set of resource IDs whose creation was still in-flight when a `flush()`
     * timed out. Each completion (success or failure) is removed from this set;
     * the first successful completion of any of these IDs triggers
     * `postCreationFlushCallback` so the content is eventually persisted.
     * Tracking IDs (not just a boolean) avoids dropping late completions when
     * multiple blocks are created concurrently. See EDITOR-7112.
     */ this.creationsTimedOutDuringFlush = new Set();
        this.createExperience = void 0;
        this.saveExperience = void 0;
        this.deleteExperience = void 0;
        this.fetchSourceInfoExperience = void 0;
        /**
     * resourceId -> timestamp (ms) of the last `syncedBlockDelete` emission, used
     * to suppress duplicates within {@link DELETE_DEDUPE_WINDOW_MS}. Only consulted
     * behind `platform_editor_blocks_patch_4`.
     */ this.recentDeleteEmissions = new Map();
        this.setPendingDeletion = (Ids, value)=>{
            if (this.viewMode === 'view') return;
            const syncBlock = this.syncBlockCache.get(Ids.resourceId);
            if (syncBlock) syncBlock.pendingDeletion = value;
        };
        this.dataProvider = dataProvider;
        this.viewMode = viewMode;
        this.isLivePage = isLivePage;
        this.syncBlockCache = new Map();
        this.creationCompletionCallbacks = new Map();
    }
}
module.exports["SourceSyncBlockStoreManager"] = $297b92badcfd6d6a$export$9c6faa8962092f36;

});

parcelRegister("9eOvr", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $b2dbadf512f98f64$var$SyncBlockActionsContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $b2dbadf512f98f64$export$1536d3aa2f6b9cd9 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($b2dbadf512f98f64$var$SyncBlockActionsContext);
} : ()=>{
    return (0, $42omo.useContext)($b2dbadf512f98f64$var$SyncBlockActionsContext);
};
const $b2dbadf512f98f64$export$5f0b55764d1d819f = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { children: children, removeSyncBlock: removeSyncBlock, fetchSyncBlockSourceInfo: fetchSyncBlockSourceInfo } = t0;
    let t1;
    if ($[0] !== fetchSyncBlockSourceInfo || $[1] !== removeSyncBlock) {
        t1 = {
            deleteSyncBlock: removeSyncBlock,
            fetchSourceInfo: fetchSyncBlockSourceInfo
        };
        $[0] = fetchSyncBlockSourceInfo;
        $[1] = removeSyncBlock;
        $[2] = t1;
    } else t1 = $[2];
    const value = t1;
    let t2;
    if ($[3] !== children || $[4] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b2dbadf512f98f64$var$SyncBlockActionsContext.Provider, {
            value: value
        }, children);
        $[3] = children;
        $[4] = value;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ children: children, removeSyncBlock: removeSyncBlock, fetchSyncBlockSourceInfo: fetchSyncBlockSourceInfo })=>{
    const value = (0, $42omo.useMemo)(()=>({
            deleteSyncBlock: removeSyncBlock,
            fetchSourceInfo: fetchSyncBlockSourceInfo
        }), [
        removeSyncBlock,
        fetchSyncBlockSourceInfo
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b2dbadf512f98f64$var$SyncBlockActionsContext.Provider, {
        value: value
    }, children);
};
module.exports["useSyncBlockActions"] = $b2dbadf512f98f64$export$1536d3aa2f6b9cd9;
module.exports["SyncBlockActionsProvider"] = $b2dbadf512f98f64$export$5f0b55764d1d819f;

});

parcelRegister("a7tZV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eTj7Y = parcelRequire("eTj7Y");


var $hWRJP = parcelRequire("hWRJP");


var $dh538 = parcelRequire("dh538");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $gtauf = parcelRequire("gtauf");

const $fb1e42d9cacf5d6e$export$2b02427d5640395b = (manager, resourceId, localId, fireAnalyticsEvent)=>{
    // Initialize both states from a single cache lookup to avoid race conditions.
    // When a block is moved/remounted, the old component's cleanup may clear the cache
    // before or after the new component mounts. By doing a single lookup, we ensure
    // consistency between syncBlockInstance and isLoading initial values.
    const [{ syncBlockInstance: syncBlockInstance, isLoading: isLoading }, setFetchState] = (0, $42omo.useState)(()=>{
        if (resourceId) {
            const initialData = manager?.referenceManager?.getInitialSyncBlockData(resourceId);
            return {
                syncBlockInstance: initialData ?? null,
                isLoading: initialData === undefined
            };
        }
        return {
            syncBlockInstance: null,
            isLoading: true
        };
    });
    // On Jira the data provider is wired asynchronously, so the manager can be
    // constructed with `dataProvider === undefined`. Fetching/subscribing in that
    // window throws `Data provider not set`, logged as a false fetch error
    // (EDITOR-7860). Gate on readiness; once the provider resolves a new manager
    // instance is created so `referenceManager` changes identity and the effect
    // below re-runs, subscribing exactly once.
    const isDataProviderReady = (0, $dh538.fg)('platform_editor_blocks_patch_3') ? manager.referenceManager.hasDataProvider?.() ?? false : true;
    const reloadData = (0, $42omo.useCallback)(async ()=>{
        if (isLoading) return;
        // Not ready: skip fetch, emit no error (see readiness note above).
        if (!isDataProviderReady) return;
        try {
            const syncBlockNode = resourceId && localId ? (0, $gtauf.createSyncBlockNode)(localId, resourceId) : null;
            if (!syncBlockNode) throw new Error('Failed to create sync block node from resourceid and localid');
            setFetchState((prev)=>({
                    ...prev,
                    isLoading: true
                }));
            // Fetch sync block data, the `subscribeToSyncBlock` will update the state once data is fetched
            await manager.referenceManager.fetchSyncBlocksData([
                syncBlockNode
            ]);
        } catch (error) {
            // EDITOR-7860: benign not-ready throw — emit no error and stay loading
            // so it resolves on retry once the provider is wired. Checked before
            // `logException` so the benign case produces no exception-tracker noise.
            // Gate-off behaviour is unchanged.
            if ((0, $awHlv.isProviderNotReadyError)(error) && (0, $dh538.fg)('platform_editor_blocks_patch_3')) {
                setFetchState((prev)=>({
                        ...prev,
                        isLoading: true
                    }));
                return;
            }
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/useFetchSyncBlockData'
            });
            fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message, resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId), (0, $cFpEg.buildFetchErrorAttribution)((0, $dh538.fg)('platform_editor_blocks_patch_3'), error.message)));
            // Set error state if fetching fails
            setFetchState({
                syncBlockInstance: {
                    resourceId: resourceId || '',
                    error: {
                        type: (0, $awHlv.SyncBlockError).Errored
                    }
                },
                isLoading: false
            });
            return;
        }
        setFetchState((prev)=>({
                ...prev,
                isLoading: false
            }));
    }, [
        isLoading,
        isDataProviderReady,
        localId,
        manager.referenceManager,
        resourceId,
        fireAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((0, $eTj7Y.isSSR)()) // in SSR, we don't need to subscribe to updates,
        // instead we rely on pre-fetched data ONLY, see initialization of syncBlockInstance above
        return;
        // Not ready: skip subscribe (it would trigger a batched fetch and a false
        // error) and keep `isLoading: true`. `isDataProviderReady` is in the deps,
        // so the effect re-runs and subscribes once the provider resolves.
        if (!isDataProviderReady) return;
        const unsubscribe = manager.referenceManager.subscribeToSyncBlock(resourceId || '', localId || '', (data)=>{
            setFetchState({
                syncBlockInstance: data,
                isLoading: false
            });
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        isDataProviderReady,
        localId,
        manager.referenceManager,
        resourceId
    ]);
    const ssrProviders = (0, $42omo.useMemo)(()=>{
        return resourceId ? manager.referenceManager.getSSRProviders(resourceId) : null;
    }, [
        resourceId,
        manager.referenceManager
    ]);
    return {
        isLoading: isLoading,
        ssrProviders: ssrProviders,
        providerFactory: manager.referenceManager.getProviderFactory(resourceId || ''),
        reloadData: reloadData,
        syncBlockInstance: syncBlockInstance
    };
};
module.exports["useFetchSyncBlockData"] = $fb1e42d9cacf5d6e$export$2b02427d5640395b;

});

parcelRegister("cQHTi", function(module, exports) {
/**
 * URL to the Atlassian support documentation for synced blocks in Confluence Cloud.
 */ const $7481da872fe5ea98$export$81b3a92cdfa3191b = 'https://support.atlassian.com/confluence-cloud/docs/reuse-content-with-synced-blocks';
module.exports["SYNCED_BLOCKS_DOCUMENTATION_URL"] = $7481da872fe5ea98$export$81b3a92cdfa3191b;

});


$parcel$global.rlb("evm5a")
//# sourceMappingURL=GoalPanel.58765ea0.js.map
